/* eslint-disable react/prop-types */
import {
	Box,
	styled,
	Typography,
	Divider,
	Grid,
	IconButton,
	Button,
	Paper,
	InputBase,
	Modal,
	Select,
	MenuItem,
	Alert,
	TextField,
	InputAdornment,
	tooltipClasses,
	Tooltip,
	ClickAwayListener,
	InputLabel,
	FormControl,
	Autocomplete,
	Drawer,
} from '@mui/material';

import React, { useEffect, useRef, useState } from 'react';

import './Charges.css';

import CloseIcon from '@mui/icons-material/Close';

import PersonIcon from '@mui/icons-material/Person';

import LoopIcon from '@mui/icons-material/Loop';
import HistoryIcon from '@mui/icons-material/History';
import { settings as s } from '../../services/Settings';

import {
	getVisitById,
	editVisitData,
	getAppointment,
	getCptCodes,
	getDxCodes,
	getLocation,
	getPatientList,
	getPracticeStaff,
	GetAttahcmentFile,
	PutAttahcmentFile,
	postCpt,
	postDx,
	PostAttahcmentFile,
	savefilepost,
	getUserSettings,
	postVisitDatalist,
	postPatNotes,
	getChargesNotes,
	moveToMaximusExport,
} from '../../services/api/apiManager';

import { useLocation, useNavigate } from 'react-router';

import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import CircularProgress from '@mui/material/CircularProgress';

import dayjs from 'dayjs';

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { CheckCircleOutline, ErrorOutline, Notes } from '@mui/icons-material';

import Snackbar from '@mui/material/Snackbar';

import DownloadIcon from '@mui/icons-material/Download';
import PublicIcon from '@mui/icons-material/Public';
import StarIcon from '@mui/icons-material/Star';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import { id } from 'date-fns/locale';

const notesDrawerPaperSx = {
	width: { xs: '100%', sm: 620, md: 720 },
	maxWidth: '100vw',
	backgroundColor: '#f7f9fd',
	borderLeft: '1px solid #dfe8f5',
	boxShadow: '-14px 0 34px rgba(15, 23, 42, 0.14)',
};

const notesDrawerHeaderSx = {
	height: 64,
	px: 2.5,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	backgroundColor: '#fff',
	borderBottom: '1px solid #e6edf7',
};

const notesTableWrapSx = {
	m: 2,
	border: '1px solid #e3ecf7',
	borderRadius: '8px',
	overflow: 'auto',
	backgroundColor: '#fff',
	maxHeight: 'calc(100vh - 96px)',
};

const notesTableSx = {
	width: '100%',
	minWidth: 620,
	borderCollapse: 'separate',
	borderSpacing: 0,
	fontFamily: 'Poppins',
	'& th': {
		position: 'sticky',
		top: 0,
		zIndex: 1,
		backgroundColor: '#f7f9fc',
		color: '#172d58',
		fontSize: '12px',
		fontWeight: 700,
		textAlign: 'left',
		padding: '10px 12px',
		borderBottom: '1px solid #e3ecf7',
		whiteSpace: 'nowrap',
	},
	'& td': {
		color: '#172d58',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: 1.55,
		padding: '11px 12px',
		borderBottom: '1px solid #edf2f8',
		verticalAlign: 'top',
		backgroundColor: '#fff',
	},
	'& tbody tr:hover td': {
		backgroundColor: '#f8fbff',
	},
	'& tbody tr:last-child td': {
		borderBottom: 0,
	},
};

export function EditCharge() {
	const navigate = useNavigate();
	const [deleteattachment, setDeleteattachment] = useState([]);
	const [editSave, setEditSave] = useState(false);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [visitData1, setVisitData1] = useState([]);
	const [visitIdData, setVisitIdData] = useState();
	const locationId = useLocation();
	const [showAlert, setShowAlert] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [loading, setLoading] = useState(false);
	const [locationData, setLocationData] = useState([]);
	const [cptCodes, setCptCodes] = useState([]);
	const [dxCodes, setDxCodes] = useState([]);
	const [data, getData] = useState([]);
	const [notes, setNotes] = useState([]);
	const [patientData, setPatientData] = useState([]);
	const [visitDate, setVisitDate] = useState();
	const [openDate, setOpenDate] = useState(false);
	const [status, setStatus] = useState('');
	const [openStatus, setOpenStatus] = useState(false);
	const [location1, setLocation1] = useState(null);
	const [openPhy, setOpenPhy] = useState(false);
	const [openPhysician, setOpenPhysician] = useState(false);
	const [providerId, setProviderId] = useState('');
	const [refPhyId, setRefPhyId] = useState('');
	const [physision, setPhysision] = useState([]);
	const [statusApi, setStatusApi] = useState('');
	const [additionalNotes, setAdditionalNotes] = useState('');
	const [statusText, setStatusText] = useState('');
	const [showDxCodes, setShowDxCodes] = useState(false);
	const [showCptCodes, setShowCptCodes] = useState(false);
	const [patientById, setPatientById] = useState([]);
	const [search, setSearch] = useState('');
	const [searchRight, setSearchRight] = useState('');
	const [dxResultSearch, setDxResultSearch] = useState('');
	const [cptResultSearch, setCptResultSearch] = useState('');
	const [searchCptData, setSearchCptData] = useState(null);
	const [searchDxData, setSearchDxData] = useState(null);
	const [changeCptCodes, setChangeCptCodes] = useState(true);
	const [file, setFile] = useState();
	const [selectedDxCodes, setSelectedDxCodes] = useState([]);
	const [checkBoxDxCodes, setCheckBoxDxCodes] = useState([]);
	const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

	const [checkBoxCptCodes, setCheckBoxCptCodes] = useState([]);
	const [cptCodeRemove, setcptCodeRemove] = useState([]);
	const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
	const [globalCptSearchLoading, setGlobalCptSearchLoading] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [intialSelectedFile, setIntialSelectedFile] = useState([]);

	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [fileId, setFileId] = useState();
	const [favoriteDx, setFavoriteDx] = useState([]);
	const [favoriteDxCodes, setFavoriteDxCodes] = useState(null);
	const [favoriteCpt, setFavoriteCpt] = useState([]);
	const [favoriteCptCodes, setFavoriteCptCodes] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const practiceID = localStorage.getItem('practice_id');
	let visitId = locationId?.state?.visit_ID;
	const patientId = locationId?.state?._patientId;
	// const username = localStorage.getItem('userName');
	const [snackbarMessage, setSnackbarMessage] = useState('');

	const [visitDataList, setVisitDataList] = useState([]);
	const [dxCodeRemove, setDxCodeRemove] = useState([]);

	const [dxCheckData, setDxCheckData] = useState();
	const [cptCheckData, setCptCheckData] = useState();
	const [selectedCpt, setSelectedCpt] = useState('');
	const [selectedDx, setSelectedDx] = useState('');
	const [allLocations, setAllLocations] = useState([]);
	const [initialdxcompare, setInitialdxcompare] = useState([]);
	const [showNotes, setShowNotes] = useState(false);

	const [selectedLocation, setSelectedLocation] = useState(null);

	const InputSelectedFile = useRef(null);

	const addCpt = {
		Input: searchRight,
	};

	const handleOpenDeleteModal = (file) => {
		setFileId(file);
		setOpenDeleteModal(true);
	};
	const toggleNotes = () => {
		setShowNotes((prev) => !prev);
	};

	const handleCloseDeleteModal = () => setOpenDeleteModal(false);
	// search Dx codes through Press Enter key
	const handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			if (search?.length >= 3) {
				searchDx({ Input: search });
				setShowDxCodes(true);
			}
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};
	const handleOpenModal = async (id) => {
		setOpenModal(true);
	};
	// search Cpt codes through Press Enter key
	const handleKeyPressCpt = (event) => {
		if (event.key === 'Enter') {
			if (searchRight?.length >= 3) {
				searchCpt(addCpt);
				setShowCptCodes(true);
			}
		}
	};
	// handle click Function out side the box
	const handleClickAwayDxBox = () => {
		setShowDxCodes(false);
	};
	const handleClickAwayCptBox = () => {
		setShowCptCodes(false);
	};
	// Patient Id is here from edit patient page

	const PatientVisitId = locationId?.state?.pastVisitId;
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};
	// Function to handle checkbox selection
	const handleCheckboxChange = (cptCode) => {
		const isChecked = selectedCheckboxes.some(
			(item) => item?.CPTCode === cptCode?.CPTCode
		);

		if (isChecked) {
			// Checkbox is already selected, so remove it
			setSelectedCheckboxes((prevSelectedCheckboxes) =>
				prevSelectedCheckboxes.filter(
					(item) => item.CPTCode !== cptCode?.CPTCode
				)
			);
		} else {
			// Checkbox is not selected, so add it
			setSelectedCheckboxes((prev) => [...prev, cptCode]);
		}
	};
	// Function to remove a selected checkbox
	const handleRemoveCheckbox = (cptCode) => {
		const removedFromSelectedCheckboxes = selectedCheckboxes.filter(
			(item) => item?.CPTCode === cptCode?.CPTCode
		);
		setcptCodeRemove(removedFromSelectedCheckboxes);

		setCheckBoxCptCodes((prevSelectedCheckboxes) =>
			prevSelectedCheckboxes.filter(
				(item) => item?.CPTCode !== cptCode?.CPTCode
			)
		);
		// Unselect the value from the selectedCheckboxes state
		setSelectedCheckboxes((prevSelectedCheckboxes) =>
			prevSelectedCheckboxes.filter(
				(item) => item?.CPTCode !== cptCode?.CPTCode
			)
		);
		const element = document.getElementById(cptCode?.CPTCode);
		if (element) {
			element.checked = false;
		}
	};
	// get Cpt by post method
	const searchCpt = async (data) => {
		setGlobalCptSearchLoading(true);
		try {
			const responce = await postCpt(data);
			if (!responce?.data?.msg) {
				setSearchCptData(responce?.data);
			} else {
				setSearchCptData([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setGlobalCptSearchLoading(false);
		}
	};
	// get Dx by post method
	const searchDx = async (data) => {
		setGlobalSearchLoading(true);
		try {
			const responce = await postDx(data);
			if (!responce?.data?.msg) {
				setSearchDxData(responce?.data);
			} else {
				setSearchDxData([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setGlobalSearchLoading(false);
		}
	};

	useEffect(() => {
		const searchText = search?.trim();

		if (!searchText || searchText.length < 3) {
			setSearchDxData(null);
			return;
		}

		const searchTimer = setTimeout(() => {
			searchDx({ Input: searchText });
			setShowDxCodes(true);
		}, 350);

		return () => clearTimeout(searchTimer);
	}, [search]);

	useEffect(() => {
		const searchText = searchRight?.trim();

		if (!searchText || searchText.length < 3) {
			setSearchCptData(null);
			return;
		}

		const searchTimer = setTimeout(() => {
			searchCpt({ Input: searchText });
			setShowCptCodes(true);
		}, 350);

		return () => clearTimeout(searchTimer);
	}, [searchRight]);

	useEffect(() => {
		const dxCodesAndDescriptions = [];
		for (let i = 1; i <= 12; i++) {
			const dxCode = visitData1[`Dxcode${i}`];
			const dxDescription = visitData1[`Dx${i}Description`];
			if (dxCode !== null) {
				dxCodesAndDescriptions.push({
					DxCode: dxCode,
					Description: dxDescription,
				});
			}
		}
		setCheckBoxDxCodes(dxCodesAndDescriptions);
		setSelectedDxCodes(dxCodesAndDescriptions);
		setInitialdxcompare(dxCodesAndDescriptions);
		// ddd
	}, [visitData1]);

	const handleDxCheckboxChange = (dxCode) => {
		const isChecked = selectedDxCodes.some(
			(item) => item?.DxCode === dxCode?.DxCode
		);

		if (isChecked) {
			setSelectedDxCodes((prevSelectedDxCodes) =>
				prevSelectedDxCodes?.filter((item) => item?.DxCode !== dxCode?.DxCode)
			);
		} else {
			setSelectedDxCodes((prev) => {
				if (prev?.length < 12) {
					return [...prev, dxCode];
				}
				return prev;
			});
		}
	};

	// Function to remove a selected DX checkbox
	const handleRemoveDxCheckbox = (dxCode) => {
		setSelectedDxCodes((prevSelectedDxCodes) =>
			prevSelectedDxCodes?.filter((item) => item?.DxCode !== dxCode?.DxCode)
		);
		setCheckBoxDxCodes((prevSelectedCheckboxes) =>
			prevSelectedCheckboxes?.filter((item) => {
				return item?.DxCode !== dxCode?.DxCode;
			})
		);
		const element = document.getElementById(dxCode?.DxCode);
		if (element) {
			element.checked = false;
		}
	};
	const getPractStuff = async () => {
		try {
			const response = await getPracticeStaff();
			setPhysision(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// Visit Data
	const getLocationData = async () => {
		try {
			const response = await getLocation();
			setLocationData(response?.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const getPatientData = async () => {
		try {
			const response = await getPatientList();
			setPatientData(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// Appointment
	const getAppointmentData = async () => {
		try {
			const response = await getAppointment();
			getData(response.data[2]);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// CPT Codes
	const getCptCode = async () => {
		try {
			const response = await getCptCodes();
			setCptCodes(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Dx Codes
	const getDxCode = async () => {
		try {
			const response = await getDxCodes();
			setDxCodes(response.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	// VisitDate
	const handleChangeStatus = (event) => {
		setStatus(event.target.value);
	};

	// handle the select option
	const handleCloseStatus = () => setOpenStatus(false);
	const handleOpenStatus = () => setOpenStatus(true);

	// API
	const getVisitDataById = async (id) => {
		try {
			const response = await getVisitById(id);
			if (response?.status === 200) {
				setPatientById(response?.data?.patient_id);
				setVisitData1(response?.data);
				setVisitIdData(response?.data?.id);
				setStatus(response?.data?.VisitStatus);
				setLocation1(response?.data?.location_id);
				setRefPhyId(response?.data?.referringPhysician_id);
				setProviderId(response?.data?.practicestaff_id);
				setVisitDate(dayjs(response?.data?.VisitDate));
				setAdditionalNotes(response?.data?.AdditionalNotes);
				const visitData = response?.data;
				const visitCpts = visitData?.visit_cpts?.map((items) => ({
					id: items?.id,
					CPTCode: items?.CPTCode,
					Description: items?.Description,
				}));

				setSelectedCheckboxes(visitCpts);
				setCheckBoxCptCodes(visitCpts);
				setSnackbarMessage('');
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const notes_PatientUpdateInformation = async (data) => {
		try {
			const response = await postPatNotes(data);
			if (response.status === 201) {
			}
			console.log('Status check:', response);
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const getStatusMessage = (status) => {
		let newText = '';
		switch (status) {
			case 'A':
				newText = 'Approved';
				break;
			case 'B':
				newText = 'Billed';
				break;
			case 'D':
				newText = 'Draft';
				break;
			case 'O':
				newText = 'Other';
				break;
			default:
				newText = 'No Status';
		}
		return newText;
	};

	const initialValues = {
		location: visitData1?.location?.Name,
		provider: visitData1?.practicestaff_id
			? physision.find((item) => item.id === visitData1.practicestaff_id)
					?.Lname +
				', ' +
				physision.find((item) => item.id === visitData1.practicestaff_id)?.Fname
			: 'No Provider',
		VisitDate: visitData1?.VisitDate
			? dayjs(visitData1.VisitDate).format('YYYY-MM-DD hh:mm A')
			: 'No Date',
		VisitStatus: getStatusMessage(visitData1?.VisitStatus),
		refPhy: visitData1?.referringPhysician_id
			? physision.find((item) => item.id === visitData1.referringPhysician_id)
					?.Lname +
				', ' +
				physision.find((item) => item.id === visitData1.referringPhysician_id)
					?.Fname
			: 'No Referring Physician',
		AdditionalNotes: visitData1?.AdditionalNotes || '',
		visit_cpts:
			visitData1?.visit_cpts?.map((items) => ({
				CPTCode: items?.CPTCode,
				Description: items?.Description,
			})) || [],
		deletedCptCode: cptCodeRemove?.map((i) => i?.Description),
		attachments:
			intialSelectedFile?.map((file) => file?.name || file?.AttachmentName) ||
			[],
		// deletedAttachments: deleteattachment,
		selectedDxCodes: initialdxcompare,
	};

	const finalValues = {
		location: selectedLocation?.Name,
		provider: providerId
			? physision.find((item) => item.id === providerId)?.Lname +
				', ' +
				physision.find((item) => item.id === providerId)?.Fname
			: 'No Provider',
		VisitDate: visitDate
			? dayjs(visitDate).format('YYYY-MM-DD hh:mm A')
			: 'No Date',
		VisitStatus: getStatusMessage(statusApi),
		refPhy: refPhyId
			? physision.find((item) => item.id === refPhyId)?.Lname +
				', ' +
				physision.find((item) => item.id === refPhyId)?.Fname
			: 'No Referring Physician',
		AdditionalNotes: additionalNotes || '',
		visit_cpts: checkBoxCptCodes || [],
		deletedCptCode: cptCodeRemove?.map((i) => i?.Description),
		attachments:
			selectedFiles?.map((file) => file?.name || file?.AttachmentName) || [],
		// deletedAttachments:
		// 	initialValues.deletedAttachments.map(
		// 		(file) => file?.name || file?.AttachmentName
		// 	) || [],
		selectedDxCodes: selectedDxCodes || [],
	};

	const compareValues = (initialValues, finalValues, deleteattachment) => {
		const notes = [];
		let deleteAttachmentHandled = false;

		for (const key in initialValues) {
			if (initialValues.hasOwnProperty(key)) {
				const initial = initialValues[key];
				const final = finalValues[key];
				if (key === 'attachments') {
					if (Array.isArray(initial) && Array.isArray(final)) {
						const addedFiles = final.filter((file) => !initial.includes(file));
						const deletedFiles = initial.filter(
							(file) => !final.includes(file)
						);
						if (addedFiles.length > 0) {
							notes.push({
								NotesText: `Attachment is added: ${addedFiles.join(', ')}`,
							});
						}
						// if (deletedFiles.length > 0 && !deleteAttachmentHandled) {
						// 	const deletedFileNames = deleteattachment?.filter((file) =>
						// 		deletedFiles.includes(file)
						// 	);

						// 	if (deletedFileNames?.length > 0) {
						// 		notes.push({
						// 			NotesText: `Attachment is deleted: ${deletedFileNames.join(', ')}`,
						// 		});
						// 		deleteAttachmentHandled = true;
						// 	}
						// }
					}
				} else if (key === 'visit_cpts') {
					if (Array.isArray(initial) && Array.isArray(final)) {
						const deletedCpts = initial.filter(
							(cpt) => !final.some((item) => item.CPTCode === cpt.CPTCode)
						);

						const addedCpts = final.filter(
							(cpt) => !initial.some((item) => item.CPTCode === cpt.CPTCode)
						);

						if (addedCpts.length > 0) {
							const addedCptText = addedCpts
								.map((item) => `${item.CPTCode} - ${item.Description}`)
								.join(', ');
							notes.push({
								NotesText: `CPT Code(s) added: ${addedCptText}`,
							});
						}
					}
				} else if (key === 'selectedDxCodes') {
					if (Array.isArray(initial) && Array.isArray(final)) {
						const addedDxCodes = final.filter(
							(dx) => !initial.some((init) => init.DxCode === dx.DxCode)
						);
						if (addedDxCodes.length > 0) {
							const addedDxText = addedDxCodes
								.map((item) => `${item.DxCode} - ${item.Description}`)
								.join(', ');
							notes.push({
								NotesText: `DX codes added: ${addedDxText}`,
							});
						}
						const deletedDxCodes = initial.filter(
							(dx) => !final.some((fin) => fin.DxCode === dx.DxCode)
						);
						if (deletedDxCodes.length > 0) {
							const deletedDxText = deletedDxCodes
								.map((item) => `${item.DxCode} - ${item.Description}`)
								.join(', ');
							notes.push({
								NotesText: `DX codes deleted: ${deletedDxText}`,
							});
						}
					}
				} else if (key === 'deletedCptCode') {
					if (Array.isArray(final) && final.length > 0) {
						const deletedCptsText = final
							.map((desc) => {
								const deletedCpt = initialValues.visit_cpts.find(
									(item) => item.Description === desc
								);
								return deletedCpt
									? `${deletedCpt.CPTCode} - ${deletedCpt.Description}`
									: desc;
							})
							.join(', ');

						notes.push({
							NotesText: `CPT Code(s) deleted: ${deletedCptsText}`,
						});
					}
				} else if (Array.isArray(initial) && Array.isArray(final)) {
					if (
						initial.length !== final.length ||
						!initial.every((val, index) => val === final[index])
					) {
						notes.push({
							NotesText: `${key} is updated from ${JSON.stringify(initial)} to ${JSON.stringify(final)}`,
						});
					}
				} else if (key === 'location') {
					if (final && initial !== final) {
						notes.push({
							NotesText: `Location is updated from "${initial || 'empty'}" to "${final || 'empty'}"`,
						});
					}
				} else if (initial !== final) {
					const initialText = initial || 'empty';
					const finalText = final || 'empty';
					notes.push({
						NotesText: `${key} is ${initial ? 'updated' : 'added'} from ${initialText} to ${finalText}`,
					});
				}
			}
		}

		return { Notes: notes };
	};

	const updatedFields = compareValues(
		initialValues,
		finalValues,
		deleteattachment
	);

	const notesLogBodyJson = {
		Patientid: patientById,
		Visit_id: visitId,
		NoteCategory: 'charge',
		practice_id: practiceID,
		Platform: 'web',
		Notes: updatedFields.Notes,
	};

	// const deleteChooseFile = async (Id, deleteFile) => {
	// 	setLoading(true);
	// 	const resp = await PutAttahcmentFile(Id, deleteFile);
	// 	if (resp.status === 200 || resp.status === 201) {
	// 		const deletedFileName = resp?.data?.AttachmentName;

	// 		setDeleteattachment((prevState) => [...prevState, deletedFileName]);
	// 		setLoading(false);
	// 		setFile(null);
	// 	}
	// 	setLoading(false);

	// };
	const deleteChooseFile = async (Id, deleteFile) => {
		setLoading(true);
		const resp = await PutAttahcmentFile(Id, deleteFile);
		let deletedFileName = '';

		if (resp.status === 200 || resp.status === 201) {
			deletedFileName = resp?.data?.AttachmentName;
			setDeleteattachment((prevState) => [...prevState, deletedFileName]);
			setLoading(false);
			setFile(null);
		}
		setLoading(false);
		return deletedFileName;
	};
	const handleFileSelect = (event) => {
		const files = Array.from(event.target.files);
		setSelectedFiles((preValue) => [...preValue, ...files]);
	};

	const handleFileRemove = (fileToRemove) => {
		setSelectedFiles((prevFiles) =>
			prevFiles.filter((file) => file !== fileToRemove)
		);
		if (InputSelectedFile.current) {
			InputSelectedFile.current.value = [];
		}
	};
	// API
	useEffect(() => {
		const getAttachmentFileData = async () => {
			setLoading(true);
			const resp = await GetAttahcmentFile(patientById);
			if (resp?.data?.length > 0) {
				const filteredData = resp?.data?.filter((item) => {
					return item?.visit_id == visitId;
				});
				setSelectedFiles(filteredData);
				setIntialSelectedFile(filteredData);
			}
			setLoading(false);
		};
		if (visitData1) {
			getAttachmentFileData();
		}
	}, [visitData1]);

	const handleDownload = (imageUrl, imageName) => {
		setLoading(true);
		const path = imageUrl?.split('\\');
		if (path?.includes('_MxChAPI')) {
			let index = path.indexOf('_MxChAPI');
			let secondPart = path.slice(index + 1).join('\\');
			let url_ = s.baseUrl + '/' + secondPart;

			fetch(url_)
				.then((response) => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.blob();
				})
				.then((blob) => {
					saveAs(blob, imageName);
				})
				.catch((error) => {
					console.error('Error downloading image:', error);

					alert('Failed to download image. Please try again later.');
				});
		} else {
			console.error('Invalid imageUrl:', imageUrl);

			alert('Invalid image URL. Unable to download.');
		}
		setLoading(false);
	};

	const favoriteCodes = async () => {
		try {
			const responce = await getUserSettings();
			if (responce?.status === 200) {
				setFavoriteDx(
					responce?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'ICD' || items?.Type === 'icd')
							);
						})
						?.reverse()
				);
			} else {
				setFavoriteDx([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};
	const favoriteCodesCpt = async () => {
		try {
			const resp = await getUserSettings();
			if (resp?.status === 200) {
				setFavoriteCpt(
					resp?.data
						?.filter((items) => {
							return (
								items?.practice_id === parseInt(practiceID) &&
								(items?.Type === 'CPT' || items?.Type === 'cpt')
							);
						})
						?.reverse()
				);
				setLoading(false);
			} else {
				setFavoriteCpt([]);
			}
		} catch (error) {
			console.log(`ERROR-->`, error);
		}
	};
	const getVisitListData = async (data) => {
		try {
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setVisitDataList(response?.data);
			} else {
				setVisitDataList([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	const filterData = {
		practice_id: practiceID,
	};
	//past visit
	const filteredVisitData = visitDataList?.filter((item) => {
		const patientNameMatch = item?.patient_id == patientById;
		return patientNameMatch;
	});

	// API
	useEffect(() => {
		getVisitListData(filterData);
		favoriteCodesCpt();
		favoriteCodes();
		getCptCode();
		getPatientData();
		getAppointmentData();
		getLocationData();
		getDxCode();
		getPractStuff();
		getVisitDataById(visitId || PatientVisitId);
	}, []);
	useEffect(() => {
		let newText;
		switch (status) {
			case 'A':
				newText = 'Approved';
				break;
			case 'B':
				newText = 'Billed';
				break;
			case 'D':
				newText = 'Draft';
				break;
			case 'O':
				newText = 'Other';
				break;
			default:
				newText = 'Billed';
		}
		setStatusText(newText);

		let newStatus;
		switch (statusText) {
			case 'Approved':
				newStatus = 'A';
				break;
			case 'Billed':
				newStatus = 'B';
				break;
			case 'Draft':
				newStatus = 'D';
				break;
			case 'Other':
				newStatus = 'O';
				break;
			default:
				newStatus = 'B';
		}
		setStatusApi(newStatus);
	}, [status, statusText]);

	// Modal
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const dxCodePOST = checkBoxDxCodes?.map((items, index) => {
		return `Dxcode:${items?.DxCode}`;
	});
	let dxCodeLastLogic = [];
	try {
		for (let i = 0; i < 12; i++) {
			dxCodeLastLogic.push(
				dxCodePOST[i] === undefined ? `Dxcode:null` : `${dxCodePOST[i]}`
			);
		}
	} catch (error) {
		console.warn(error);
	}
	const dxCodePostObj = dxCodeLastLogic?.reduce((acc, currentValue, index) => {
		const [key, value] = currentValue.split(':');
		acc[key + (index + 1)] = value === 'null' ? null : value;
		return acc;
	}, {});
	const dxCodeDescPOST = checkBoxDxCodes?.map((items, index) => {
		return `DxADescription:${items?.Description}`;
	});
	let dxDescLastLogic = [];
	try {
		for (let i = 0; i < 12; i++) {
			dxDescLastLogic.push(
				dxCodeDescPOST[i] === undefined
					? `DxADescription:null`
					: `${dxCodeDescPOST[i]}`
			);
		}
	} catch (error) {
		console.warn(`there is an error of unbound index of an array `, error);
	}
	const dxCodeDescPostObj = dxDescLastLogic?.reduce(
		(acc, currentValue, index) => {
			const [key, value] = currentValue.split(':');
			acc[key.toString().replace('A', index + 1)] =
				value === 'null' ? null : value;
			return acc;
		},
		{}
	);
	//  Update Data
	const updateData = {
		...dxCodePostObj,
		...dxCodeDescPostObj,
		practice_id: visitData1?.practice_id,
		patient_id: visitData1?.patient_id,
		admission_id: visitData1?.admission_id || undefined,
		// location_id: visitData1?.location_id || undefined,
		location_id: selectedLocation?.id || undefined,
		practicestaff_id: providerId || undefined,
		referringPhysician_id: refPhyId || undefined,
		VisitDate: dayjs(visitDate).format('YYYY-MM-DD'),
		VisitStatus: statusApi,
		AdditionalNotes: additionalNotes,
		visit_cpts: checkBoxCptCodes,
	};
	const OSW_id = localStorage.getItem('OSW_id');
	const moveToMaximusData = {
		OSW_id: OSW_id,
		visitids: visitId,
		practice_id: practiceID,
	};
	const editVisit = async (id, data) => {
		setEditSave(true);
		const response = await editVisitData(id, data);
		if (response.status === 200) {
			// if (OSW_id == '1') {
			// 	const resp2 = await moveToMaximusExport(moveToMaximusData);
			// }
			if (selectedFiles?.length > 0) {
				for (let files of selectedFiles) {
					if (files) {
						try {
							const formData = new FormData();
							if (files) {
								formData.append('file', files);
								formData.append(
									'filepath',
									visitData1?.practice_id + '/' + visitData1?.id
								);
								const savefile = await savefilepost(formData);
								const storeFileName = savefile?.data?.file_name;
								const storeFilePath = savefile?.data?.file_path;
								const AttachmentFilePost = {
									visit_id: visitData1?.id,
									patient_id: visitData1?.patient_id,
									AttachmentName: storeFileName,
									Path: storeFilePath,
									Type: files?.type,
								};
								if (
									AttachmentFilePost?.Path !== undefined ||
									AttachmentFilePost?.Type !== undefined
								) {
									const attachFile =
										await PostAttahcmentFile(AttachmentFilePost);
									console.log('attachFile', attachFile);
								}
							}
						} catch (error) {
							console.error('Error:', error);
						}
					}
				}
			}
			setPostSucessfully(true);
			setTimeout(() => {
				navigate('/charges');
			}, 1000);
			setEditSave(false);
		} else {
			setPostSucessfully(false);
		}
		handleClickSnackbar();
		setAdditionalNotes('');
		setStatus('');
		setLocation1(null);
		setCheckBoxCptCodes();
		setCheckBoxDxCodes();
		setRefPhyId('');
	};
	const dobDate = new Date(visitData1?.patient?.DOB);
	const year = dobDate.getFullYear();
	const month = (dobDate.getMonth() + 1).toString().padStart(2, '0');
	const day = dobDate.getDate().toString().padStart(2, '0');
	const formattedDOB = `${year}-${month}-${day}`;
	const currentDate = new Date();
	// Calculate the age
	let age = currentDate.getFullYear() - dobDate.getFullYear();
	if (
		currentDate.getMonth() < dobDate.getMonth() ||
		(currentDate.getMonth() === dobDate.getMonth() &&
			currentDate.getDate() < dobDate.getDate())
	) {
		age--;
	}
	const formatAdmissionDate = (dateString) => {
		if (!dateString) return null;
		const admissionDate = new Date(dateString);
		const year = admissionDate.getFullYear();
		const month = (admissionDate.getMonth() + 1).toString().padStart(2, '0');
		const day = admissionDate.getDate().toString().padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	// handle Searches DxCodes
	const [searchFavDxCode, setSearchFavDxCode] = useState('');
	const handleDxCodes = (event) => {
		setSearchFavDxCode(event.target.value);
	};
	// Filtering logic Favourite DxCodes...
	const filteredFavDxCodes = favoriteDxCodes?.setting_codes?.filter(
		(item) =>
			item?.Code?.toLowerCase().includes(searchFavDxCode?.toLowerCase()) ||
			item?.CodeDescription?.toLowerCase().includes(
				searchFavDxCode?.toLowerCase()
			)
	);

	// handle Searches Cpt Codes
	const [searchFavCptCode, setSearchFavCptCode] = useState('');
	const handleCptCodes = (event) => {
		setSearchFavCptCode(event.target.value);
	};
	// Filtering logic Favourite Cpt Codes...
	const filteredFavCptCodes = favoriteCptCodes?.setting_codes?.filter(
		(items) =>
			items?.Code?.toLowerCase().includes(searchFavCptCode?.toLowerCase()) ||
			items?.CodeDescription?.toLowerCase().includes(
				searchFavCptCode?.toLowerCase()
			)
	);

	useEffect(() => {
		const getPatientNotesData = async (patient_id, practice_id, visit_id) => {
			try {
				// Params of PatientId, Practice Id & Visit Id is or not
				if (patient_id) {
					const response = await getChargesNotes(
						patient_id,
						practice_id,
						visit_id
					);

					if (response.status === 200) {
						// Sort notes by created_date in descending order
						var notes = response.data.notes;
						const sortedData = notes.sort((a, b) => {
							return new Date(b.created_date) - new Date(a.created_date);
						});
						setNotes(sortedData);
					} else {
						console.log('Unexpected status code:', response.status);
					}
				}
			} catch (error) {
				console.error('Error fetching patient notes:', error);
			}
		};
		getPatientNotesData(patientById, practiceID, visitId);
	}, [patientById, practiceID, visitId]);

	const chargeCardSx = {
		background: '#fff',
		border: '1px solid #dce6f3',
		borderRadius: '8px',
		p: '12px',
	};
	const chargeFieldSx = {
		'& .MuiInputBase-root': {
			height: 40,
			borderRadius: '6px',
			backgroundColor: '#fff',
			fontFamily: 'Poppins',
			fontSize: '13px',
		},
		'& .MuiInputLabel-root': {
			display: 'none',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: '#d6e2f2',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#b9cbe3',
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#2E68BA',
			borderWidth: '1px',
		},
		'& .MuiInputBase-input': {
			color: '#122b55',
			fontSize: '13px',
			padding: '9px 12px',
		},
	};
	const chargeLabelSx = {
		display: 'block',
		mb: 0.5,
		fontSize: '12px',
		fontWeight: 600,
		color: '#17345f',
		fontFamily: 'Poppins',
	};
	const codePanelSx = {
		...chargeCardSx,
		height: { xl: 520, lg: 470, md: 'auto', xs: 'auto' },
		minHeight: { md: 'auto', xs: 'auto' },
		display: 'flex',
		flexDirection: 'column',
	};
	const stepTitle = (number, title, subtitle) => (
		<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
			<Box
				sx={{
					width: 16,
					height: 16,
					borderRadius: '50%',
					bgcolor: '#2f6fd8',
					color: '#fff',
					fontSize: 10,
					fontWeight: 700,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					mt: '2px',
					flex: '0 0 auto',
				}}
			>
				{number}
			</Box>
			<Box>
				<Typography sx={{ fontSize: 14, fontWeight: 700, color: '#005bff' }}>
					{title}
				</Typography>
				{subtitle && (
					<Typography sx={{ fontSize: 11, color: '#9a9a9a', mt: '2px' }}>
						{subtitle}
					</Typography>
				)}
			</Box>
		</Box>
	);
	const addDxToCharge = (item) => {
		const dx = {
			DxCode: item?.Code || item?.DxCode,
			Description: item?.Description || item?.CodeDescription,
		};
		if (!dx.DxCode) return;
		setSelectedDxCodes((prev = []) => {
			if (prev?.some((selected) => selected?.DxCode === dx.DxCode)) return prev;
			return prev?.length < 12 ? [...prev, dx] : prev;
		});
		setCheckBoxDxCodes((prev = []) => {
			if (prev?.some((selected) => selected?.DxCode === dx.DxCode)) return prev;
			return prev?.length < 12 ? [...prev, dx] : prev;
		});
	};
	const addCptToCharge = (item) => {
		const cpt = {
			CPTCode: item?.Code || item?.CPTCode,
			Description: item?.Description || item?.CodeDescription,
		};
		if (!cpt.CPTCode) return;
		setSelectedCheckboxes((prev = []) => {
			if (prev?.some((selected) => selected?.CPTCode === cpt.CPTCode))
				return prev;
			return [...prev, cpt];
		});
		setCheckBoxCptCodes((prev = []) => {
			if (prev?.some((selected) => selected?.CPTCode === cpt.CPTCode))
				return prev;
			return [...prev, cpt];
		});
	};
	const dxSearchResults =
		searchDxData != null ? searchDxData : filteredFavDxCodes || [];
	const cptSearchResults =
		searchCptData != null ? searchCptData : filteredFavCptCodes || [];
	const filterCodeResults = (items, value) => {
		const term = value?.trim()?.toLowerCase();
		if (!term) return items || [];
		return (items || [])?.filter((item) =>
			[
				item?.Code,
				item?.DxCode,
				item?.CPTCode,
				item?.Description,
				item?.CodeDescription,
			]
				.filter(Boolean)
				.some((text) => String(text)?.toLowerCase()?.includes(term))
		);
	};
	const renderSearchList = (items, type) => {
		const isDx = type === 'dx';
		const loadingResults = isDx ? globalSearchLoading : globalCptSearchLoading;
		if (loadingResults) {
			return (
				<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
					<CircularProgress size={24} />
				</Box>
			);
		}
		if (!items?.length) {
			return (
				<Typography sx={{ color: '#8a97ad', fontSize: 12, py: 2 }}>
					Search by code or description to see results.
				</Typography>
			);
		}
		return items?.map((item, index) => {
			const code = item?.Code || item?.DxCode || item?.CPTCode;
			const description = item?.Description || item?.CodeDescription || '';
			return (
				<Box
					key={`${type}-${code}-${index}`}
					onClick={() => (isDx ? addDxToCharge(item) : addCptToCharge(item))}
					sx={{
						display: 'grid',
						gridTemplateColumns: '24px 64px minmax(0, 1fr)',
						alignItems: 'center',
						minHeight: 40,
						borderBottom: '1px solid #dce8fb',
						cursor: 'pointer',
						px: 1.25,
						columnGap: 0.5,
						'&:hover': { bgcolor: '#f6f9ff' },
					}}
				>
					<Typography sx={{ color: '#005bff', fontSize: 22, lineHeight: 1 }}>
						+
					</Typography>
					<Typography sx={{ color: '#005bff', fontSize: 13, fontWeight: 700 }}>
						{code}
					</Typography>
					<Typography
						noWrap
						title={description}
						sx={{ color: '#17345f', fontSize: 13 }}
					>
						{description}
					</Typography>
				</Box>
			);
		});
	};
	const renderSelectedCodes = (items, type) => {
		const isDx = type === 'dx';
		return items?.map((item, index) => {
			const code = isDx ? item?.DxCode : item?.CPTCode;
			const description = item?.Description || '';
			return (
				<Box
					key={`${type}-selected-${code}-${index}`}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 1,
						bgcolor: '#eaf3ff',
						border: '1px solid #cfe2ff',
						borderRadius: '5px',
						px: 1.2,
						py: 0,
						mb: '6px',
						height: 34,
						minHeight: 34,
					}}
				>
					<Typography
						noWrap
						title={`${code} [${description}]`}
						sx={{ color: '#005bff', fontSize: 13 }}
					>
						{code} [{description}]
					</Typography>
					<IconButton
						size="small"
						onClick={() =>
							isDx ? handleRemoveDxCheckbox(item) : handleRemoveCheckbox(item)
						}
					>
						<CloseIcon sx={{ color: '#ff1f1f', fontSize: 18 }} />
					</IconButton>
				</Box>
			);
		});
	};
	const renderCodePanel = ({
		number,
		title,
		type,
		searchValue,
		setSearchValue,
		favoriteValue,
		setFavoriteValue,
		favoriteOptions,
		searchHandler,
		searchResults,
		selectedItems,
		clearSelected,
		loadingResults,
	}) => {
		const resultFilterValue = type === 'dx' ? dxResultSearch : cptResultSearch;
		const setResultFilterValue =
			type === 'dx' ? setDxResultSearch : setCptResultSearch;
		const visibleSearchResults = filterCodeResults(
			searchResults,
			resultFilterValue
		);

		return (
			<Box sx={codePanelSx}>
				{stepTitle(number, title)}
				<Typography sx={{ mt: 1.5, mb: 0.5, fontSize: 12, color: '#111' }}>
					Search In
				</Typography>
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' },
						border: '1px solid #d5dfeb',
						borderRadius: '6px',
						overflow: 'hidden',
						mb: 1,
						minHeight: 42,
					}}
				>
					<Button
						startIcon={<PublicIcon sx={{ fontSize: 18 }} />}
						sx={{
							justifyContent: 'flex-start',
							minHeight: 40,
							color: '#0a234a',
							borderRadius: 0,
							borderBottom: {
								xs: '1px solid #d5dfeb',
								sm: '2px solid #1f77d0',
							},
							fontSize: 13,
						}}
					>
						All Codes
					</Button>
					<Autocomplete
						size="small"
						value={favoriteValue}
						onChange={(event, newValue) => {
							setFavoriteValue(newValue);
							if (type === 'dx') {
								setShowDxCodes(Boolean(newValue));
								setSearchDxData(null);
								setSearch('');
							} else {
								setShowCptCodes(Boolean(newValue));
								setSearchCptData(null);
								setSearchRight('');
							}
						}}
						options={favoriteOptions}
						getOptionLabel={(option) => option?.SettingName || ''}
						renderInput={(params) => (
							<TextField
								{...params}
								placeholder="Favorite Lists"
								InputProps={{
									...params.InputProps,
									startAdornment: (
										<>
											<StarIcon
												sx={{ color: '#f6b400', fontSize: 20, mr: 0.75 }}
											/>
											{params.InputProps.startAdornment}
										</>
									),
								}}
							/>
						)}
						sx={{
							'& .MuiInputBase-root': {
								height: 40,
								borderRadius: 0,
								fontSize: 12,
								'& fieldset': { border: 0 },
							},
							'& .MuiInputBase-input': {
								padding: '8px 10px !important',
							},
						}}
					/>
					<Button
						startIcon={<OpenInNewIcon sx={{ fontSize: 18 }} />}
						onClick={() => {
							handleOpenModal();
							setSelectedDx('');
							setSelectedCpt('');
						}}
						sx={{
							justifyContent: 'flex-start',
							minHeight: 40,
							color: '#7d8da6',
							borderRadius: 0,
							fontSize: 13,
						}}
					>
						Last Visit
					</Button>
				</Box>
				<TextField
					size="small"
					fullWidth
					value={searchValue}
					onChange={(e) => {
						setSearchValue(e.target.value);
						setFavoriteValue(null);
					}}
					onKeyPress={(event) => {
						if (event.key === 'Enter' && searchValue?.length >= 3) {
							searchHandler();
						}
					}}
					placeholder="Search by Code or Description"
					sx={{
						mb: 2,
						'& .MuiInputBase-root': { height: 36, borderRadius: '6px' },
						'& input': { fontSize: 12 },
					}}
				/>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						mb: 1,
					}}
				>
					<Typography sx={{ fontSize: 13, fontWeight: 700 }}>
						Selected {type === 'dx' ? 'Dx' : 'CPT'} Codes (
						{selectedItems?.length || 0})
					</Typography>
					<Button
						size="small"
						onClick={clearSelected}
						sx={{ color: '#ff1f1f', textTransform: 'none', fontSize: 12 }}
					>
						Clear all
					</Button>
				</Box>
				<Box
					sx={{
						minHeight: 44,
						height: 114,
						maxHeight: 114,
						overflowY: 'auto',
						pr: 0.5,
						'&::-webkit-scrollbar': { width: '4px' },
						'&::-webkit-scrollbar-thumb': {
							background: '#b8c8de',
							borderRadius: '6px',
						},
					}}
				>
					{renderSelectedCodes(selectedItems, type)}
				</Box>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 1,
						mt: 1,
						mb: 1,
					}}
				>
					<Typography sx={{ fontSize: 13, fontWeight: 700 }}>
						Search Results ({visibleSearchResults?.length || 0})
					</Typography>
					<TextField
						size="small"
						value={resultFilterValue}
						onChange={(e) => setResultFilterValue(e.target.value)}
						placeholder="Search results..."
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<SearchIcon sx={{ fontSize: 16, color: '#7d8da6' }} />
								</InputAdornment>
							),
						}}
						sx={{
							width: 150,
							'& .MuiInputBase-root': {
								height: 28,
								borderRadius: '6px',
								bgcolor: '#fff',
								fontSize: 12,
							},
							'& .MuiInputBase-input': {
								py: '4px',
								fontSize: 12,
							},
						}}
					/>
				</Box>
				<Box
					sx={{
						border: '1px solid #dce6f3',
						borderRadius: '6px',
						overflow: 'hidden',
						bgcolor: '#fff',
						flex: 1,
						minHeight: 140,
						height: { xl: 275, lg: 235, md: 260, sm: 240, xs: 220 },
						maxHeight: { xl: 275, lg: 235, md: 260, sm: 240, xs: 220 },
						overflowY: 'auto',
						'&::-webkit-scrollbar': { width: '4px' },
						'&::-webkit-scrollbar-thumb': {
							background: '#b8c8de',
							borderRadius: '6px',
						},
					}}
				>
					{loadingResults ? (
						<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
							<CircularProgress size={24} />
						</Box>
					) : (
						renderSearchList(visibleSearchResults, type)
					)}
				</Box>
			</Box>
		);
	};

	return (
		<Box
			sx={{
				p: 0.75,
				bgcolor: '#f6f8fb',
				minHeight: 'calc(100vh - 46px)',
				fontFamily: 'Poppins',
				overflowX: 'hidden',
			}}
		>
			{showAlert && (
				<Alert
					sx={{ zIndex: 1000, width: '100%', position: 'fixed' }}
					icon={
						postSucessfully === false ? (
							<ErrorOutline fontSize="inherit" />
						) : (
							<CheckCircleOutline fontSize="inherit" />
						)
					}
					severity={postSucessfully === false ? 'error' : 'success'}
				>
					{!postSucessfully ? 'Error not Update' : 'Successfully Update'}
				</Alert>
			)}
			<Box sx={chargeCardSx}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start',
						gap: 2,
						mb: 1,
					}}
				>
					{stepTitle(1, 'Charge Context', 'Select Patient and Charge Details')}
					<Button
						size="small"
						startIcon={<ContentCopyIcon sx={{ fontSize: 16 }} />}
						onClick={() => {
							handleOpenModal();
							setSelectedDx('');
							setSelectedCpt('');
						}}
						sx={{ color: '#005bff', textTransform: 'none', fontWeight: 700 }}
					>
						Copy from last visit
					</Button>
				</Box>
				<Grid container spacing={1.2} alignItems="center">
					<Grid item xs={12} md={4}>
						<Typography sx={{ ...chargeLabelSx, visibility: 'hidden' }}>
							Patient
						</Typography>
						<Box
							sx={{
								display: 'grid',
								gridTemplateColumns: '32px minmax(0, 1fr) 32px 72px',
								alignItems: 'center',
								gap: 1,
								bgcolor: '#f1f3f5',
								borderRadius: '5px',
								minHeight: 48,
								px: 1,
							}}
						>
							<PersonIcon sx={{ color: '#3d6fb4' }} />
							<Box sx={{ minWidth: 0 }}>
								<Typography noWrap sx={{ fontSize: 13, fontWeight: 700 }}>
									{`${visitData1?.patient?.Lname || ''}, ${visitData1?.patient?.Fname || ''}`}
								</Typography>
								<Typography noWrap sx={{ fontSize: 11, color: '#999' }}>
									MRN: {visitData1?.patient?.MRN || '-'} {'  '} •{' '}
									{formattedDOB && !isNaN(age) ? formattedDOB : '-'} {'  '} •{' '}
									{visitData1?.patient?.Gender || '-'}
								</Typography>
							</Box>
							<CloseIcon sx={{ color: '#111' }} />
							<Button
								size="small"
								onClick={() => navigate('/patients')}
								sx={{ textTransform: 'none', color: '#2E68BA' }}
							>
								Change
							</Button>
						</Box>
					</Grid>
					<Grid item xs={12} sm={6} md={1.8}>
						<Typography sx={chargeLabelSx}>Location *</Typography>
						<Autocomplete
							disablePortal
							size="small"
							options={locationData}
							getOptionLabel={(option) => option?.Name || ''}
							value={
								selectedLocation ||
								locationData?.find(
									(loc) => loc?.Name === visitData1?.location?.Name
								) ||
								null
							}
							onChange={(event, newValue) => setSelectedLocation(newValue)}
							renderInput={(params) => (
								<TextField {...params} placeholder="Select location" />
							)}
							sx={chargeFieldSx}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={1.6}>
						<Typography sx={chargeLabelSx}>Provider *</Typography>
						<Autocomplete
							disablePortal
							size="small"
							options={physision || []}
							value={physision?.find((item) => item?.id === providerId) || null}
							getOptionLabel={(option) =>
								option ? `${option?.Lname || ''}, ${option?.Fname || ''}` : ''
							}
							onChange={(event, newValue) => setProviderId(newValue?.id || '')}
							ListboxProps={{
								sx: {
									maxHeight: 220,
									'& .MuiAutocomplete-option': {
										minHeight: 34,
										fontSize: 13,
										fontFamily: 'Poppins',
									},
								},
							}}
							renderInput={(params) => (
								<TextField {...params} placeholder="Select provider" />
							)}
							sx={chargeFieldSx}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={1.3}>
						<Typography sx={chargeLabelSx}>Charge Date *</Typography>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DateTimePicker
								value={visitDate}
								onChange={(newValue) => setVisitDate(newValue)}
								open={openDate}
								onOpen={() => setOpenDate(true)}
								onClose={() => setOpenDate(false)}
								onClick={() => setOpenDate(true)}
								slotProps={{ textField: { size: 'small', fullWidth: true } }}
								sx={chargeFieldSx}
							/>
						</LocalizationProvider>
					</Grid>
					<Grid item xs={12} sm={6} md={1.8}>
						<Typography sx={chargeLabelSx}>Referring Physician</Typography>
						<Autocomplete
							disablePortal
							size="small"
							options={physision || []}
							value={physision?.find((item) => item?.id === refPhyId) || null}
							getOptionLabel={(option) =>
								option ? `${option?.Lname || ''}, ${option?.Fname || ''}` : ''
							}
							onChange={(event, newValue) => setRefPhyId(newValue?.id || '')}
							ListboxProps={{
								sx: {
									maxHeight: 220,
									'& .MuiAutocomplete-option': {
										minHeight: 34,
										fontSize: 13,
										fontFamily: 'Poppins',
									},
								},
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder="Select referring physician"
								/>
							)}
							sx={chargeFieldSx}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={1.5}>
						<Typography sx={chargeLabelSx}>Status *</Typography>
						<FormControl fullWidth size="small" sx={chargeFieldSx}>
							<Select
								value={status}
								onChange={handleChangeStatus}
								open={openStatus}
								onOpen={handleOpenStatus}
								onClose={handleCloseStatus}
							>
								<MenuItem value="D">Draft</MenuItem>
								<MenuItem value="B">Billed</MenuItem>
								<MenuItem value="A">Approved</MenuItem>
								<MenuItem value="O">Other</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</Box>
			<Grid container spacing={1.5} sx={{ mt: 1.5 }}>
				<Grid item xs={12} lg={4.3}>
					{renderCodePanel({
						number: 2,
						title: 'Diagnosis (DX Codes)',
						type: 'dx',
						searchValue: search,
						setSearchValue: setSearch,
						favoriteValue: favoriteDxCodes,
						setFavoriteValue: setFavoriteDxCodes,
						favoriteOptions: favoriteDx,
						searchHandler: () => {
							searchDx({ Input: search });
							setShowDxCodes(true);
						},
						searchResults: dxSearchResults,
						selectedItems: checkBoxDxCodes || [],
						clearSelected: () => {
							setCheckBoxDxCodes([]);
							setSelectedDxCodes([]);
						},
						loadingResults: globalSearchLoading,
					})}
				</Grid>
				<Grid item xs={12} lg={4.3}>
					{renderCodePanel({
						number: 3,
						title: 'Procedures (CPT Codes)',
						type: 'cpt',
						searchValue: searchRight,
						setSearchValue: setSearchRight,
						favoriteValue: favoriteCptCodes,
						setFavoriteValue: setFavoriteCptCodes,
						favoriteOptions: favoriteCpt,
						searchHandler: () => {
							searchCpt(addCpt);
							setShowCptCodes(true);
						},
						searchResults: cptSearchResults,
						selectedItems: checkBoxCptCodes || [],
						clearSelected: () => {
							setCheckBoxCptCodes([]);
							setSelectedCheckboxes([]);
						},
						loadingResults: globalCptSearchLoading,
					})}
				</Grid>
				<Grid item xs={12} lg={3.4} sx={{ display: 'flex' }}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: 1.5,
							width: '100%',
							height: { xl: 520, lg: 470, md: 'auto', xs: 'auto' },
						}}
					>
						<Box sx={chargeCardSx}>
							{stepTitle(4, 'Additional Notes')}
							<Box
								component="textarea"
								value={additionalNotes}
								onChange={(e) => setAdditionalNotes(e.target.value)}
								placeholder="Enter Additional Notes here"
								maxLength={1000}
								sx={{
									mt: 1,
									width: '100%',
									height: 75,
									resize: 'none',
									overflowY: 'auto',
									boxSizing: 'border-box',
									border: 'none',
									outline: 'none',
									bgcolor: '#f1f3f5',
									borderRadius: '6px',
									p: '12px',
									fontFamily: 'Poppins',
									fontSize: 13,
									color: '#0a234a',
									'&::placeholder': { color: '#8a97ad' },
									'&::-webkit-scrollbar': { width: '4px' },
									'&::-webkit-scrollbar-thumb': {
										background: '#b8c8de',
										borderRadius: '6px',
									},
								}}
							/>
							<Typography
								sx={{ textAlign: 'right', color: '#999', fontSize: 12 }}
							>
								{additionalNotes?.length || 0}/1000
							</Typography>
						</Box>
						<Box sx={{ ...chargeCardSx, flex: 1 }}>
							{stepTitle(5, 'Attachments')}
							<Button
								component="label"
								sx={{
									mt: 1.5,
									width: '100%',
									height: 96,
									border: '1px dashed #d8e1ed',
									bgcolor: '#f3f5f8',
									color: '#0a234a',
									textTransform: 'none',
									display: 'flex',
									flexDirection: 'column',
									gap: 0.5,
								}}
							>
								<Typography sx={{ fontSize: 26, color: '#2f6fd8' }}>
									☁
								</Typography>
								<Typography sx={{ fontSize: 12 }}>
									Drag and Drop Files here or <b>Click to Upload</b>
								</Typography>
								<Typography sx={{ color: '#8a97ad', fontSize: 11 }}>
									Max File Size: 500MB (PDF, IMG, PPT,DOC)
								</Typography>
								<input
									ref={InputSelectedFile}
									type="file"
									multiple
									style={{ display: 'none' }}
									onChange={handleFileSelect}
									accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
								/>
							</Button>
							<Typography
								sx={{ mt: 1.5, mb: 0.5, fontSize: 13, fontWeight: 700 }}
							>
								Uploaded Files({selectedFiles?.length || 0})
							</Typography>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									gap: 1,
									maxHeight: 160,
									overflowY: 'auto',
									pr: 0.5,
									'&::-webkit-scrollbar': { width: '4px' },
									'&::-webkit-scrollbar-thumb': {
										background: '#b8c8de',
										borderRadius: '6px',
									},
								}}
							>
								{loading ? (
									<Box
										sx={{ display: 'flex', justifyContent: 'center', py: 2 }}
									>
										<CircularProgress size={24} />
									</Box>
								) : selectedFiles?.length > 0 ? (
									selectedFiles?.map((file, index) => (
										<Box
											key={index}
											sx={{
												display: 'grid',
												gridTemplateColumns: '28px minmax(0, 1fr) 28px',
												alignItems: 'center',
												gap: 1,
												border: '1px solid #e6edf5',
												boxShadow: '0 1px 4px rgba(15, 35, 70, 0.08)',
												px: 1,
												py: 0.8,
											}}
										>
											<DownloadIcon
												onClick={() => {
													if (!file?.name) {
														handleDownload(file?.Path, file?.AttachmentName);
													}
												}}
												sx={{
													color: '#6ba5ff',
													cursor: file?.name ? 'default' : 'pointer',
												}}
											/>
											<Typography noWrap sx={{ fontSize: 13 }}>
												{file?.name || file?.AttachmentName}
											</Typography>
											<IconButton
												size="small"
												onClick={() => {
													file?.id
														? handleOpenDeleteModal(file)
														: handleFileRemove(file);
												}}
											>
												<CloseIcon sx={{ color: '#ff1f1f', fontSize: 18 }} />
											</IconButton>
										</Box>
									))
								) : (
									<Typography sx={{ color: '#8a97ad', fontSize: 12 }}>
										No files uploaded.
									</Typography>
								)}
							</Box>
						</Box>
					</Box>
				</Grid>
			</Grid>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					gap: 1,
					mt: 1.5,
					pb: 1,
				}}
			>
				<CustomButton
					onClick={() => toggleNotes()}
					variant="outlined"
					startIcon={<HistoryIcon sx={{ fontSize: 18 }} />}
					sx={{
						backgroundColor: '#fff',
						color: '#2E68BA',
						borderColor: '#c8d3e1',
						cursor: 'pointer',
						minWidth: 180,
						px: 2.5,
						whiteSpace: 'nowrap',
						boxShadow: 'none',
						'&:hover': { backgroundColor: '#f4f8ff', borderColor: '#2E68BA' },
					}}
				>
					Notes History
				</CustomButton>
				<CustomButton
					onClick={() => navigate('/charges')}
					variant="outlined"
					startIcon={<CloseIcon sx={{ fontSize: 18 }} />}
					sx={{
						backgroundColor: '#fff',
						color: '#3f4652',
						borderColor: '#c8d3e1',
						cursor: 'pointer',
						minWidth: 125,
						px: 2.5,
						whiteSpace: 'nowrap',
						boxShadow: 'none',
						'&:hover': { backgroundColor: '#f7f9fc', borderColor: '#9aa8ba' },
					}}
				>
					Cancel
				</CustomButton>
				<CustomButton
					onClick={() => {
						if (checkBoxCptCodes?.length < 1) {
							setSnackbarMessage('CPT Code must be selected');
							setOpenSnackbar(true);
						} else {
							editVisit(visitId || PatientVisitId, updateData);
							notes_PatientUpdateInformation(notesLogBodyJson);
						}
					}}
					variant="contained"
					startIcon={<SaveIcon sx={{ fontSize: 18 }} />}
					sx={{
						backgroundColor: '#2E68BA',
						minWidth: 125,
						px: 2.5,
						whiteSpace: 'nowrap',
						boxShadow: '0 2px 6px rgba(46, 104, 186, 0.25)',
						'&:hover': { backgroundColor: '#24589f' },
					}}
					disabled={editSave ? true : false}
				>
					Save
				</CustomButton>
			</Box>
			<Snackbar
				open={openSnackbar}
				autoHideDuration={1000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
			>
				<Alert
					onClose={handleCloseSnackbar}
					severity={
						!postSucessfully || snackbarMessage !== '' ? 'error' : 'success'
					}
					variant="filled"
					sx={{
						height: '3rem',
						textAlign: 'center',
						fontSize: {
							xl: '14px',
							lg: '14px',
							md: '14px',
							sm: '12px',
							xs: '12px',
						},
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					{!postSucessfully
						? 'Error'
						: snackbarMessage !== ''
							? snackbarMessage
							: 'Edit Charge Successfully!'}
				</Alert>
			</Snackbar>
			<Drawer
				anchor="right"
				open={showNotes}
				onClose={() => setShowNotes(false)}
				sx={{
					'& .MuiDrawer-paper': {
						...notesDrawerPaperSx,
					},
				}}
			>
				<Box sx={notesDrawerHeaderSx}>
					<Typography
						variant="h6"
						sx={{
							fontWeight: 700,
							color: '#172d58',
							fontFamily: 'Poppins',
							fontSize: '18px',
						}}
					>
						Notes History
					</Typography>
					<IconButton
						onClick={() => setShowNotes(false)}
						sx={{
							width: 34,
							height: 34,
							color: '#63718a',
							'&:hover': {
								backgroundColor: '#eef5ff',
								color: '#1f66ff',
							},
						}}
					>
						<CloseIcon />
					</IconButton>
				</Box>
				<Box sx={notesTableWrapSx}>
					<Box component="table" sx={notesTableSx}>
						<thead>
							<tr>
								<th style={{ width: 118 }}>Date</th>
								<th style={{ width: 150 }}>User Name</th>
								<th>Notes</th>
							</tr>
						</thead>
						<tbody>
							{notes?.map((note) => (
								<tr key={note.id}>
									<td>{dayjs(note.created_date).format('MMM DD, YYYY')}</td>
									<td>{note?.created_by_name}</td>
									<td>
										<Tooltip title={note.note_text} placement="top">
											<span>
												{note.note_text?.length > 150
													? note.note_text?.slice(0, 150) + '...'
													: note.note_text}
											</span>
										</Tooltip>
									</td>
								</tr>
							))}
						</tbody>
					</Box>
				</Box>
			</Drawer>
			<Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
				<Box sx={style}>
					<Box display={'flex'} justifyContent={'flex-end'}>
						<IconButton
							sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
							onClick={handleCloseDeleteModal}
						>
							<CloseIcon sx={{ color: '#ED2828' }} />
						</IconButton>
					</Box>
					<Box display={'flex'} flexDirection={'column'} gap={'10px'}>
						<Typography
							variant="h5"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Confirm?
						</Typography>
						<Typography
							variant="h6"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Are You Sure To Delete Attachment File?
						</Typography>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '90px', py: '8px' }}
								onClick={handleCloseDeleteModal}
							>
								Cancel
							</Button>
							<Button
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '90px', py: '8px' }}
								onClick={async () => {
									const deletedFileName = await deleteChooseFile(fileId?.id, {
										Deleted: true,
									});
									const actionNotes = [
										{
											NotesText: `Attachment '${deletedFileName || 'unknown'}' is deleted`,
										},
									];
									const notesLogBodyJson = {
										Patientid: patientById,
										Visit_id: visitId,
										NoteCategory: 'charge',
										practice_id: practiceID,
										Platform: 'web',
										Notes: actionNotes,
									};
									await postPatNotes(notesLogBodyJson);
									await deleteChooseFile(fileId?.id, { Deleted: true });
									handleFileRemove(fileId);
									handleCloseDeleteModal();
								}}
							>
								Delete
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>
			<Modal open={openModal}>
				<Box
					sx={{ ...style, width: { xs: '92vw', sm: 560 }, maxHeight: '75vh' }}
				>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						alignItems={'center'}
						padding={'10px 14px'}
						sx={{ borderBottom: '1px solid #dce6f3' }}
					>
						<Typography fontSize={'16px'} fontWeight={'bold'} color={'#0a234a'}>
							Past Visits
						</Typography>
						<IconButton onClick={handleCloseModal}>
							<CloseIcon sx={{ color: '#0a234a' }} />
						</IconButton>
					</Box>
					<Box sx={{ overflowY: 'auto', p: 1.5, maxHeight: '62vh' }}>
						{filteredVisitData?.map((item, key) => {
							const dxCodesAndDescriptions = [];
							for (let i = 1; i <= 12; i++) {
								const dxCode = item[`Dxcode${i}`];
								const dxDescription = item[`Dx${i}Description`];
								if (dxCode !== null && dxCode) {
									dxCodesAndDescriptions.push({
										DxCode: dxCode,
										Description: dxDescription,
									});
								}
							}
							return (
								<Box
									key={key}
									sx={{
										display: 'grid',
										gridTemplateColumns: '118px 1px minmax(0, 1fr) 44px',
										alignItems: 'center',
										gap: 1.5,
										border: '1px solid #dce6f3',
										borderRadius: '6px',
										px: 2,
										py: 1.25,
										mb: 0.75,
										bgcolor: '#fff',
									}}
								>
									<Box>
										<Typography
											sx={{
												fontSize: 12,
												color: '#5b6472',
												lineHeight: 1.4,
												fontWeight: 500,
											}}
										>
											Visit Date
										</Typography>
										<Typography
											sx={{
												fontWeight: 600,
												fontSize: 12,
												color: '#0a234a',
												lineHeight: 1.4,
											}}
										>
											{formatAdmissionDate(item?.VisitDate)}
										</Typography>
									</Box>
									<Box sx={{ height: 36, bgcolor: '#d6e2f2' }} />
									<Box sx={{ minWidth: 0 }}>
										<Typography
											noWrap
											sx={{ fontSize: 12, color: '#5b6472', lineHeight: 1.8 }}
										>
											<Box
												component="span"
												sx={{ fontWeight: 600, color: '#0a234a', mr: 1 }}
											>
												DX Codes:
											</Box>
											{dxCodesAndDescriptions
												?.map((dx) => dx?.DxCode)
												?.join(', ') || 'No Dx Added'}
										</Typography>
										<Typography
											noWrap
											sx={{ fontSize: 12, color: '#5b6472', lineHeight: 1.8 }}
										>
											<Box
												component="span"
												sx={{ fontWeight: 600, color: '#0a234a', mr: 1 }}
											>
												CPT Codes:
											</Box>
											{item?.visit_cpts
												?.map((cpt) => cpt?.CPTCode)
												?.join(', ') || 'No CPT codes added'}
										</Typography>
									</Box>
									<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
										<IconButton
											size="small"
											sx={{
												width: 38,
												height: 38,
												border: '1px solid #FD7702',
												color: '#fff',
												fontWeight: 600,
												fontSize: 16,
												bgcolor: '#FD7702',
												'&:hover': {
													bgcolor: '#D76A05',
													borderColor: '#D76A05',
												},
											}}
											onClick={() => {
												handleCloseModal();
												setCheckBoxDxCodes(dxCodesAndDescriptions);
												setSelectedDxCodes(dxCodesAndDescriptions);
												setCheckBoxCptCodes(
													item?.visit_cpts?.map((cpt) => ({
														CPTCode: cpt?.CPTCode,
														Description: cpt?.Description,
													})) || []
												);
											}}
										>
											+
										</IconButton>
									</Box>
								</Box>
							);
						})}
					</Box>
				</Box>
			</Modal>
		</Box>
	);

	return (
		<Box
			sx={{
				overflowX: 'hidden',
				padding: '8px',
			}}
		>
			<Box sx={{ padding: '0 10px 5px 0px' }} id={'nav'}>
				{showAlert && (
					<Alert
						sx={{ zIndex: 1000, width: '100%', position: 'fixed' }}
						icon={
							postSucessfully === false ? (
								<ErrorOutline fontSize="inherit" />
							) : (
								<CheckCircleOutline fontSize="inherit" />
							)
						}
						severity={postSucessfully === false ? 'error' : 'success'}
					>
						{!postSucessfully ? 'Error not Update' : 'Successfully Update'}
					</Alert>
				)}
				{/* Past visit and Charge info, DX Codes etc. */}
				<Box sx={{ padding: '10px 2px' }}>
					{/* edit charge Info */}
					<Grid container>
						<Grid
							item
							container
							xl={4.5}
							lg={4.5}
							md={4.5}
							sm={12}
							xs={12}
							sx={{ padding: '2px 10px' }}
						>
							<Box
								display={'flex'}
								alignItems={'center'}
								sx={{
									backgroundColor: '#F9F9FC',
									padding: '10px',
									borderRadius: '6px',
									width: '100%',
									border: '0.5px solid #C2C2C2',
									position: 'relative',
								}}
							>
								<Grid container>
									<Grid item xs={12} lg={12} md={12} sm={12} xl={12}>
										<Typography
											color={'#BC1111'}
											fontWeight={500}
											fontFamily={'Poppins'}
											sx={{
												fontSize: {
													xl: '13px',
													lg: '10px',
													md: '9px',
													sm: '9px',
													xs: '9px',
												},
												position: 'absolute',
												top: '-10px',
												left: '10px',
												background: '#F9F9FC',
												padding: '0 5px',
											}}
										>
											Patient Info
										</Typography>
									</Grid>
									<Grid item xs={6} lg={6} md={6} sm={6} xl={6}>
										<Box display={'flex'} gap={'5px'} alignItems={'center'}>
											<PersonIcon color="primary" />
											<Typography
												color={'#EB0000'}
												fontWeight={700}
												fontFamily={'Poppins'}
												sx={{
													fontSize: {
														xl: '15px',
														lg: '10px',
														md: '9px',
														sm: '9px',
														xs: '9px',
													},
												}}
											>
												{`${visitData1?.patient?.Fname} ${visitData1?.patient?.Lname} `}
											</Typography>
										</Box>
										<Typography
											color={'#2E476B'}
											fontWeight={600}
											fontFamily={'Poppins'}
											sx={{
												fontSize: {
													xl: '15px',
													lg: '10px',
													md: '9px',
													sm: '9px',
													xs: '9px',
												},
											}}
										>
											{formattedDOB && !isNaN(age) && (
												<>
													{formattedDOB} / {age} yrs{'-'}
													{visitData1?.patient?.Gender}
												</>
											)}
										</Typography>
									</Grid>
									<Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
										<Box height={'40px'}>
											{/*<Typography
												color={'#8F8E8E'}
												fontWeight={400}
												fontFamily={'Poppins'}
												sx={{
													fontSize: {
														xl: '15px',
														lg: '10px',
														md: '9px',
														sm: '9px',
														xs: '9px',
													},
												}}
											>
												Location
											</Typography>*/}
											{/*<CustomWidthTooltip
												arrow
												title={visitData1?.location?.Name}
												placement="top-start"
											>
												<Typography
													color={'#000000'}
													fontWeight={400}
													fontFamily={'Poppins'}
													sx={{
														fontSize: {
															xl: '15px',
															lg: '10px',
															md: '9px',
															sm: '9px',
															xs: '9px',
														},
													}}
												>
													{visitData1?.location?.Name?.length > 15
														? visitData1?.location?.Name?.slice(0, 15) + '....'
														: visitData1?.location?.Name}
												</Typography>
											</CustomWidthTooltip>*/}
											<Autocomplete
												disablePortal
												id="combo-box-demo"
												size="small"
												options={locationData}
												getOptionLabel={(option) => option?.Name || ''}
												value={
													selectedLocation ||
													locationData?.find(
														(loc) => loc?.Name === visitData1?.location?.Name
													) ||
													null
												}
												onChange={(event, newValue) => {
													setSelectedLocation(newValue);
												}}
												sx={{
													'.MuiInputBase-root': {
														height: '40px', // Adjust the input height
													},
													'.MuiInputBase-input': {
														fontSize: '12px', // Adjust input font size
														color: '#8F8E8E',
													},
													'.MuiAutocomplete-option': {
														fontSize: '12px', // Adjust dropdown option font size
													},
													width: 180,
													height: {
														xl: '40px',
														lg: '40px',
														md: '40px',
														sm: '40px',
														xs: '40px',
													},
												}}
												renderInput={(params) => (
													<TextField {...params} label="Locations" />
												)}
											/>
										</Box>
									</Grid>
								</Grid>
								<Box
									display={'flex'}
									alignItems={'center'}
									flexDirection={'column'}
									justifyContent={'flex-end'}
									width={'20%'}
								>
									<Typography
										color={'#8F8E8E'}
										fontWeight={400}
										fontFamily={'Poppins'}
										fontSize={'14px'}
										sx={{
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '9px',
												sm: '9px',
												xs: '9px',
											},
										}}
									>
										Past Visits
									</Typography>
									<IconButton
										onClick={() => {
											handleOpenModal();
											setSelectedDx('');
											setSelectedCpt('');
										}}
										sx={{
											width: '30px',
											height: '30px',
											cursor: 'pointer',
										}}
									>
										<LoopIcon
											sx={{
												fontSize: {
													xl: '19px',
													lg: '16px',
													md: '13px',
													sm: '12px',
													xs: '12px',
												},
											}}
										/>
									</IconButton>
								</Box>
							</Box>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={7.5}
							lg={7.5}
							xl={7.5}
							sx={{
								padding: '5px',
								border: '1px solid lightgray',
								borderRadius: '6px',
								position: 'relative',
							}}
						>
							<Box sx={{ display: 'flex', flexDirection: 'column' }}>
								<Typography
									color={'#BC1111'}
									fontWeight={500}
									fontFamily={'Poppins'}
									sx={{
										fontSize: {
											xl: '13px',
											lg: '10px',
											md: '9px',
											sm: '9px',
											xs: '9px',
										},
										position: 'absolute',
										top: '-10px',
										left: '10px',
										background: '#F9F9FC',
										padding: '0 5px',
									}}
								>
									Edit Charge Info
								</Typography>
								<Box>
									<Grid
										container
										spacing={2}
										sx={{
											display: 'flex',
											alignItems: 'flex-end',
											padding: '7px',
										}}
									>
										{/* item1 */}
										<Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
											<FormControl fullWidth>
												<InputLabel htmlFor="demo-select-small">
													Charge Status
												</InputLabel>
												<Select
													labelId="demo-select-small-label"
													id="demo-select-small"
													label={'Charge Status'}
													value={status}
													size="small"
													onChange={handleChangeStatus}
													fullWidth
													sx={{
														color: '#8F8E8E',
													}}
													open={openStatus}
													onOpen={handleOpenStatus}
													onClose={handleCloseStatus}
												>
													<MenuItem value="D">Draft</MenuItem>
													<MenuItem value="B">Billed</MenuItem>
													<MenuItem value="A">Approved</MenuItem>
													<MenuItem value="O">Other</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										{/* item2 */}
										<Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
											<LocalizationProvider dateAdapter={AdapterDayjs}>
												<DemoContainer components={['DatePicker']}>
													<DemoItem>
														<DateTimePicker
															value={visitDate}
															label={'Charge Date'}
															onChange={(newValue) => setVisitDate(newValue)}
															open={openDate}
															onOpen={() => setOpenDate(true)}
															onClose={() => setOpenDate(false)}
															onClick={() => setOpenDate(true)}
															slotProps={{ textField: { size: 'small' } }}
														/>
													</DemoItem>
												</DemoContainer>
											</LocalizationProvider>
										</Grid>
										{/* item 3 */}
										<Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
											<FormControl fullWidth size="small">
												<InputLabel htmlFor="demo-select-small">
													{' '}
													Provider
												</InputLabel>
												<Select
													labelId="demo-select-small-label"
													id="demo-select-small"
													label={'Provider'}
													size="small"
													value={providerId}
													onChange={(e) => setProviderId(e.target.value)}
													fullWidth
													sx={{
														color: '#8F8E8E',
													}}
													open={openPhy}
													onClose={() => setOpenPhy(false)}
													onOpen={() => setOpenPhy(true)}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '200px',
																width: '150px',
																overflowY: 'auto',

																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{physision?.map((item, key) => {
														return (
															<MenuItem key={key} value={item?.id}>
																{item?.Lname + ', ' + item?.Fname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Grid>
										{/* item 4 */}
										<Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
											<FormControl fullWidth size="small">
												<InputLabel htmlFor="demo-select-small">
													{' '}
													Referring Phy
												</InputLabel>
												<Select
													labelId="demo-select-small-label"
													id="demo-select-small"
													label={'Referring Phy'}
													size="small"
													value={refPhyId}
													onChange={(e) => setRefPhyId(e.target.value)}
													fullWidth
													sx={{
														color: '#8F8E8E',
													}}
													open={openPhysician}
													onClose={() => setOpenPhysician(false)}
													onOpen={() => setOpenPhysician(true)}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '200px',
																width: '100px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{physision?.map((item, key) => {
														return (
															<MenuItem key={key} value={item?.id}>
																{item?.Lname + ', ' + item?.Fname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Box>
							</Box>
						</Grid>
					</Grid>

					<Box sx={{ padding: '10px 1px', overflow: 'auto' }}>
						<Grid container spacing={1}>
							{/* Edit Diagnosis */}
							<Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
								<Box
									display={'flex'}
									flexDirection={'column'}
									sx={{ padding: '10px' }}
								>
									<Box
										display={'flex'}
										justifyContent={'space-between'}
										alignItems={'center'}
									>
										<Typography
											color={'#BC1111'}
											fontWeight={500}
											fontFamily={'Poppins'}
											sx={{
												fontSize: {
													xl: '15px',
													lg: '10px',
													md: '9px',
													sm: '9px',
													xs: '9px',
												},
											}}
										>
											{/* DX Codes */}
										</Typography>
									</Box>
									{/* Diagnosis Table */}
									<Box>
										<ClickAwayListener onClickAway={handleClickAwayDxBox}>
											<Paper
												elevation={4}
												sx={{
													borderTopLeftRadius: '5px',
													borderTopRightRadius: '5px',
													pb: '0.5rem',
													bgcolor: '#FAFAFA',
												}}
											>
												{/* head */}
												<DiagnosisBox>
													<Box display={'flex'} alignItems={'center'}>
														<Typography
															color={'#FFFFFF'}
															fontWeight={500}
															fontFamily={'Poppins'}
															sx={{
																fontSize: {
																	xl: '15px',
																	lg: '14px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
															}}
														>
															Add DX Codes
														</Typography>
													</Box>
													{/* search dx codes */}
													<Box
														display={'flex'}
														alignItems={'center'}
														gap={'10px'}
													>
														<Autocomplete
															size="small"
															value={favoriteDxCodes}
															onChange={(event, newValue) => {
																setFavoriteDxCodes(newValue);
																if (!newValue || newValue.length === 0) {
																	setShowDxCodes(false);
																} else {
																	setShowDxCodes(true);
																}
																setSearchDxData(null);
																setSearch('');
															}}
															id="country-select-demo"
															sx={{
																width: 150,
																backgroundColor: 'white',
																borderRadius: '1.2rem',
																height: {
																	xl: '33px',
																	lg: '33px',
																	md: '33px',
																	sm: '33px',
																	xs: '33px',
																},
																'.MuiInputBase-root': {
																	height: {
																		xl: '33px',
																		lg: '33px',
																		md: '33px',
																		sm: '33px',
																		xs: '33px',
																	},
																},
															}}
															options={favoriteDx}
															autoHighlight
															getOptionLabel={(option) => option?.SettingName}
															renderOption={(props, option) => (
																<Box
																	component="li"
																	sx={{
																		'& > img': { mr: 2, flexShrink: 0 },
																		borderRadius: '1.2rem',
																		fontSize: '13px',
																	}}
																	{...props}
																>
																	{option?.SettingName}
																</Box>
															)}
															renderInput={(params) => (
																<StyledTextField
																	{...params}
																	label="Favourite"
																	inputProps={{
																		...params.inputProps,
																		autoComplete: 'new-password',
																		autoComplete: 'off',
																		placeholder: 'Search By List.',
																	}}
																	sx={{
																		height: {
																			xl: '33px',
																			lg: '33px',
																			md: '33px',
																			sm: '33px',
																			xs: '33px',
																		},
																		'.MuiInputBase-input': {
																			height: '100%',
																			boxSizing: 'border-box',
																			padding: '0 14px',
																		},
																	}}
																/>
															)}
														/>
														<input
															value={search}
															onKeyPress={handleKeyPress}
															onChange={(e) => {
																const targetValue = e.target.value;
																setSearch(targetValue);
																setFavoriteDxCodes(null);
															}}
															onClick={() => {
																if (search?.length > 0) {
																	setShowDxCodes(!showDxCodes);
																}
															}}
															style={{
																boxShadow: 'none',
																border: '1px solid #00000030',
																borderRadius: '1.2rem',
																height: {
																	xl: '30px',
																	lg: '30px',
																	md: '30px',
																	sm: '30px',
																	xs: '30px',
																},
																padding: '5px 10px',
																width: '9rem',
															}}
															size="small"
															placeholder="Search..."
														/>
														<Button
															onClick={() => {
																searchDx({ Input: search });
																setShowDxCodes(true);
															}}
															disabled={search?.length < 3 ? true : false}
															sx={{
																textTransform: 'capitalize',
																height: {
																	xl: '15px',
																	lg: '15px',
																	md: '12px',
																	sm: '12px',
																	xs: '12px',
																},
																fontSize: {
																	xl: '15px',
																	lg: '13px',
																	md: '10px',
																	sm: '10px',
																	xs: '10px',
																},
																width: '5rem',
																fontWeight: 300,
																borderRadius: '10rem',
																padding: '15px 20px',
																bgcolor: 'white',
																color: 'black',
																'&:hover': {
																	backgroundColor: 'white',
																},
															}}
															variant="contained"
														>
															Search
														</Button>
													</Box>
												</DiagnosisBox>
												<Divider />
												<Box
													sx={{
														minHeight: '12rem',
													}}
												>
													{!showDxCodes && (
														<Grid
															width={'100%'}
															display={
																checkBoxDxCodes?.length <= 0 ? 'flex' : 'none'
															}
															justifyContent={'center'}
															alignItems={'center'}
															height={'100%'}
															sx={{
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
															}}
														>
															{' '}
															Write a Code Description to search
														</Grid>
													)}
													{/* Button Above Favorite Dx Codes */}
													{favoriteDxCodes != null && (
														<Box
															sx={{
																display: 'flex',
																alignItems: 'center',
																height: '50px',
																mr: '1rem',
																justifyContent: 'flex-end',
															}}
														>
															<TextField
																id="outlined-basic"
																placeholder="Search Dx Codes"
																variant="outlined"
																size="small"
																value={searchFavDxCode}
																onChange={handleDxCodes}
																sx={{
																	'& .MuiOutlinedInput-root': {
																		borderRadius: '1rem', // Adjust border radius
																		height: '35px', // Adjust height
																		fontSize: '12px', // Adjust font size
																	},
																	'& .MuiInputLabel-root': {
																		fontSize: '12px', // Adjust label font size
																	},
																	'& .MuiOutlinedInput-input': {
																		fontSize: '12px', // Adjust input text font size
																	},
																}}
															/>
														</Box>
													)}
													{/* DropDown */}
													<Box
														sx={{
															opacity: showDxCodes ? 1 : 0,
															height: {
																xl: showDxCodes ? '29vh' : '0px',
																lg: showDxCodes ? '29vh' : '0px',
																md: showDxCodes ? '29vh' : '0px',
																sm: showDxCodes ? '27vh' : '0px',
																xs: showDxCodes ? '25vh' : '0px',
															},
															transition: 'all 0.4s ease-in',
															border: showDxCodes
																? '1px solid #00000026'
																: 'none',
															margin: '-1px 5px 5px 5px',
															borderBottomRightRadius: '5px',
															borderBottomLeftRadius: '5px',
															backgroundColor: 'white',
														}}
													>
														<Box
															sx={{
																opacity: showDxCodes ? 1 : 0,
																height: {
																	xl: showDxCodes ? '29vh' : '0px',
																	lg: showDxCodes ? '29vh' : '0px',
																	md: showDxCodes ? '29vh' : '0px',
																	sm: showDxCodes ? '27vh' : '0px',
																	xs: showDxCodes ? '25vh' : '0px',
																},
																transition: 'all 1s ease-in',
															}}
														>
															{globalSearchLoading ? (
																<Grid
																	sx={{
																		opacity: showDxCodes ? 1 : 0,
																		display: 'flex',
																		justifyContent: 'center',
																		alignItems: 'center',
																		height: '100%',
																		height: {
																			xl: showDxCodes ? '24vh' : '0px',
																			lg: showDxCodes ? '24vh' : '0px',
																			md: showDxCodes ? '24vh' : '0px',
																			sm: showDxCodes ? '22vh' : '0px',
																			xs: showDxCodes ? '20vh' : '0px',
																		},
																		transition: 'all 0.7s ease-in',
																	}}
																>
																	<CircularProgress />
																</Grid>
															) : (
																<Grid
																	sx={{
																		opacity: showDxCodes ? 1 : 0,
																		height: {
																			xl: showDxCodes ? '24vh' : '0px',
																			lg: showDxCodes ? '24vh' : '0px',
																			md: showDxCodes ? '24vh' : '0px',
																			sm: showDxCodes ? '22vh' : '0px',
																			xs: showDxCodes ? '20vh' : '0px',
																		},
																		overflowY: 'auto',
																		'&::-webkit-scrollbar': {
																			width: '3.5px',
																		},
																		'&::-webkit-scrollbar-track': {
																			background: '#f1f1f1',
																		},
																		'&::-webkit-scrollbar-thumb': {
																			background: '#2E68BA',
																			borderRadius: '5px',
																		},
																		transition: 'all 1s ease-in',
																	}}
																	display={showDxCodes ? 'flex' : 'none'}
																	flexDirection={'column'}
																>
																	{searchDxData?.length === 0 && (
																		<Grid
																			width={'100%'}
																			display={'flex'}
																			justifyContent={'center'}
																			alignItems={'center'}
																			height={'100%'}
																		>
																			{' '}
																			No Match Found
																		</Grid>
																	)}
																	{searchDxData == null &&
																		favoriteDxCodes == null &&
																		showDxCodes && (
																			<Grid
																				width={'100%'}
																				display={'flex'}
																				justifyContent={'center'}
																				alignItems={'center'}
																				height={'100%'}
																				sx={{
																					fontSize: {
																						xl: '15px',
																						lg: '10px',
																						md: '9px',
																						sm: '9px',
																						xs: '9px',
																					},
																				}}
																			>
																				{' '}
																				Write a Code Description to search
																			</Grid>
																		)}
																	{searchDxData != null
																		? searchDxData?.map((item, key) => {
																				return (
																					<Box
																						key={key}
																						sx={{ m: '8px 0 0 2rem' }}
																					>
																						<Box display={'flex'} gap={'10px'}>
																							<Grid
																								display={'flex'}
																								gap={'10px'}
																							>
																								<input
																									checked={selectedDxCodes?.some(
																										(items) =>
																											items?.DxCode ==
																											item?.Code
																									)}
																									type="checkbox"
																									id={item?.Code}
																									onClick={() => {
																										handleDxCheckboxChange({
																											DxCode: item?.Code,
																											Description:
																												item?.Description,
																										});
																									}}
																									style={{ cursor: 'pointer' }}
																								/>
																								<Grid minWidth={'70px'}>
																									<label
																										htmlFor={item?.Code}
																										style={{
																											color: '#1D60C5',
																											fontWeight: 600,
																											fontFamily: 'Poppins',
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																											cursor: 'pointer',
																										}}
																									>
																										{`${item?.Code}`}
																									</label>
																								</Grid>
																							</Grid>
																							<Box
																								display={'flex'}
																								alignItems={'center'}
																							>
																								<CustomWidthTooltip
																									arrow
																									title={item?.Description}
																									placement="top-start"
																								>
																									<Typography
																										fontWeight={400}
																										fontFamily={'Poppins'}
																										sx={{
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																										}}
																									>
																										{item?.Description?.length >
																										65
																											? item?.Description?.slice(
																													0,
																													65
																												) + '....'
																											: item?.Description}
																									</Typography>
																								</CustomWidthTooltip>
																							</Box>
																						</Box>

																						<Divider color={'#DCE8FB'} />
																					</Box>
																				);
																			})
																		: filteredFavDxCodes != null
																			? filteredFavDxCodes?.map((item, key) => {
																					return (
																						<Box
																							key={key}
																							sx={{ m: '8px 0 0 2rem' }}
																						>
																							<Box
																								display={'flex'}
																								gap={'10px'}
																							>
																								<Grid
																									display={'flex'}
																									gap={'10px'}
																								>
																									<input
																										checked={selectedDxCodes?.some(
																											(items) =>
																												items?.DxCode ==
																												item?.Code
																										)}
																										type="checkbox"
																										id={item?.Code}
																										onClick={() => {
																											handleDxCheckboxChange({
																												DxCode: item?.Code,
																												Description:
																													item?.CodeDescription,
																											});
																										}}
																										style={{
																											cursor: 'pointer',
																										}}
																									/>
																									<Grid minWidth={'70px'}>
																										<label
																											htmlFor={item?.Code}
																											style={{
																												color: '#1D60C5',
																												fontWeight: 600,
																												fontFamily: 'Poppins',
																												fontSize: {
																													xl: '15px',
																													lg: '10px',
																													md: '9px',
																													sm: '9px',
																													xs: '9px',
																												},
																												cursor: 'pointer',
																											}}
																										>
																											{`${item?.Code}`}
																										</label>
																									</Grid>
																								</Grid>
																								<Box
																									display={'flex'}
																									alignItems={'center'}
																								>
																									<CustomWidthTooltip
																										arrow
																										title={
																											item?.CodeDescription
																										}
																										placement="top-start"
																									>
																										<Typography
																											fontWeight={400}
																											fontFamily={'Poppins'}
																											sx={{
																												fontSize: {
																													xl: '15px',
																													lg: '10px',
																													md: '9px',
																													sm: '9px',
																													xs: '9px',
																												},
																											}}
																										>
																											{item?.CodeDescription
																												?.length > 65
																												? item?.CodeDescription?.slice(
																														0,
																														65
																													) + '....'
																												: item?.CodeDescription}
																										</Typography>
																									</CustomWidthTooltip>
																								</Box>
																							</Box>

																							<Divider color={'#DCE8FB'} />
																						</Box>
																					);
																				})
																			: ''}
																</Grid>
															)}

															<Box
																display="flex"
																gap={'5px'}
																justifyContent={'flex-end'}
																margin={'auto 5px 5px 5px'}
																sx={{
																	opacity: showDxCodes ? 1 : 0,
																	height: showDxCodes ? '30px' : '0px',
																	transition: 'all 0.5s ease-in',
																}}
															>
																<Button
																	onClick={() => {
																		setShowDxCodes(false);
																		setSearchDxData(null);
																		setSelectedDxCodes([]);
																		setSearch('');
																	}}
																	variant="contained"
																	sx={{
																		backgroundColor: '#ED2828',
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																		'&:hover': {
																			backgroundColor: '#ED2828',
																		},
																	}}
																>
																	Cancel
																</Button>
																<Button
																	disabled={
																		selectedDxCodes?.length <= 0 ? true : false
																	}
																	onClick={() => {
																		setCheckBoxDxCodes((pre) => {
																			const mergedDxCodes = [
																				...pre,
																				...selectedDxCodes,
																			];
																			return Array.from(new Set(mergedDxCodes));
																		});
																		setShowDxCodes(false);
																		setSearchDxData(null);
																		setSearch('');
																	}}
																	variant="contained"
																	sx={{
																		backgroundColor: '#D76A05',
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																		'&:hover': {
																			backgroundColor: '#D76A05',
																		},
																	}}
																>
																	Add
																</Button>
															</Box>
														</Box>
													</Box>
													{/* Box of close icon */}
													{checkBoxDxCodes?.length > 0 && !showDxCodes && (
														<Box
															display={'flex'}
															flexDirection={'column'}
															gap={'5px'}
															m={'5px 0'}
															padding={'0 2px'}
															sx={{
																height: {
																	xl: '24vh',
																	lg: '29vh',
																	md: '29vh',
																	sm: '27vh',
																	xs: '25vh',
																},
																overflow: 'auto',
															}}
														>
															{checkBoxDxCodes?.map((item, i) => (
																<Box key={i}>
																	<Box>
																		<Paper>
																			<CustomBoxDiagosis>
																				<Box
																					display={'flex'}
																					alignItems={'center'}
																				>
																					<CustomWidthTooltip
																						arrow
																						title={`${item?.DxCode} [ ${item?.Description}]`}
																						placement="top-start"
																					>
																						<CustomTypoDiagosis
																							sx={{
																								fontSize: {
																									xl: '15px',
																									lg: '10px',
																									md: '9px',
																									sm: '9px',
																									xs: '9px',
																								},
																							}}
																						>
																							{item.DxCode +
																								` [ ${item?.Description?.length > 50 ? item.Description?.slice(0, 50) + '...' : item.Description}] `}
																						</CustomTypoDiagosis>
																					</CustomWidthTooltip>
																				</Box>
																				<Box>
																					<IconButton
																						sx={{
																							ml: 'auto',
																							cursor: 'pointer',
																						}}
																						onClick={() =>
																							handleRemoveDxCheckbox(item)
																						}
																					>
																						<CloseIcon
																							sx={{
																								color: '#ED2828',
																								fontSize: {
																									xl: '15px',
																									lg: '10px',
																									md: '9px',
																									sm: '9px',
																									xs: '9px',
																								},
																							}}
																						/>
																					</IconButton>
																				</Box>
																			</CustomBoxDiagosis>
																		</Paper>
																	</Box>
																</Box>
															))}
														</Box>
													)}
												</Box>
											</Paper>
										</ClickAwayListener>
									</Box>
								</Box>
							</Grid>
							<Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
								<Box
									display={'flex'}
									flexDirection={'column'}
									sx={{ padding: '10px' }}
								>
									<Box
										display={'flex'}
										justifyContent={'space-between'}
										alignItems={'center'}
									>
										<Typography
											color={'#BC1111'}
											fontWeight={500}
											fontFamily={'Poppins'}
											sx={{
												fontSize: {
													xl: '15px',
													lg: '10px',
													md: '9px',
													sm: '9px',
													xs: '9px',
												},
											}}
										>
											{' '}
											{/* CPT Codes */}
										</Typography>
									</Box>
									{/* CPT Diagnosis Table */}
									<Box>
										<ClickAwayListener onClickAway={handleClickAwayCptBox}>
											<Paper
												elevation={4}
												sx={{
													borderTopLeftRadius: '5px',
													borderTopRightRadius: '5px',
													pb: '0.5rem',
													bgcolor: '#FAFAFA',
												}}
											>
												{/* head */}
												<DiagnosisBox>
													<Box display={'flex'} alignItems={'center'}>
														<Typography
															color={'#FFFFFF'}
															fontWeight={500}
															fontFamily={'Poppins'}
															sx={{
																fontSize: {
																	xl: '15px',
																	lg: '14px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
															}}
														>
															Add CPT codes
														</Typography>
													</Box>
													{/* search dx codes */}
													<Box
														display={'flex'}
														alignItems={'center'}
														gap={'10px'}
													>
														<Autocomplete
															size="small"
															value={favoriteCptCodes}
															onChange={(event, newValue) => {
																setFavoriteCptCodes(newValue);
																if (!newValue || newValue?.length === 0) {
																	setShowCptCodes(false);
																} else {
																	setShowCptCodes(true);
																}
																setSearchCptData(null);
																setSearchRight('');
															}}
															id="country-select-demo"
															sx={{
																width: 150,
																backgroundColor: 'white',
																borderRadius: '1.2rem',
																height: {
																	xl: '33px',
																	lg: '33px',
																	md: '33px',
																	sm: '33px',
																	xs: '33px',
																},
																'.MuiInputBase-root': {
																	height: {
																		xl: '33px',
																		lg: '33px',
																		md: '33px',
																		sm: '33px',
																		xs: '33px',
																	},
																},
															}}
															options={favoriteCpt}
															autoHighlight
															getOptionLabel={(option) => option?.SettingName}
															renderOption={(props, option) => (
																<Box
																	component="li"
																	sx={{
																		'& > img': { mr: 2, flexShrink: 0 },
																		borderRadius: '1.2rem',
																	}}
																	{...props}
																>
																	{option?.SettingName}
																</Box>
															)}
															renderInput={(params) => (
																<StyledTextField
																	{...params}
																	label="Favourite"
																	inputProps={{
																		...params.inputProps,
																		autoComplete: 'new-password',
																		autoComplete: 'off',
																		placeholder: 'Search By List.',
																	}}
																	sx={{
																		height: {
																			xl: '33px',
																			lg: '33px',
																			md: '33px',
																			sm: '33px',
																			xs: '33px',
																		},
																		'.MuiInputBase-input': {
																			height: '100%',
																			boxSizing: 'border-box',
																			padding: '0 14px',
																		},
																	}}
																/>
															)}
														/>
														<input
															value={searchRight}
															onKeyPress={handleKeyPressCpt}
															onChange={(e) => {
																const targetValue = e.target.value;
																setSearchRight(targetValue);
																setFavoriteCptCodes(null);
															}}
															onClick={() => {
																if (searchCptData?.length > 0) {
																	setShowCptCodes(!showCptCodes);
																}
															}}
															style={{
																boxShadow: 'none',
																border: '1px solid #00000030',
																borderRadius: '1.2rem',
																height: {
																	xl: '30px',
																	lg: '30px',
																	md: '30px',
																	sm: '30px',
																	xs: '30px',
																},
																padding: '5px 10px',
																width: '9rem',
															}}
															size="small"
															placeholder="Search..."
														/>
														<Button
															onClick={() => {
																searchCpt(addCpt);
																setShowCptCodes(true);
															}}
															disabled={searchRight?.length < 3 ? true : false}
															sx={{
																textTransform: 'capitalize',
																height: {
																	xl: '15px',
																	lg: '15px',
																	md: '12px',
																	sm: '12px',
																	xs: '12px',
																},
																fontSize: {
																	xl: '15px',
																	lg: '13px',
																	md: '10px',
																	sm: '10px',
																	xs: '10px',
																},
																width: '5rem',
																fontWeight: 300,
																borderRadius: '10rem',
																padding: '15px 20px',
																bgcolor: 'white',
																color: 'black',
																'&:hover': {
																	backgroundColor: 'white',
																},
															}}
															variant="contained"
														>
															Search
														</Button>
													</Box>
												</DiagnosisBox>
												{/* selecter of cpt codes */}
												<Box
													sx={{
														minHeight: '12rem',
													}}
												>
													{searchCptData == null && !showCptCodes && (
														<Grid
															width={'100%'}
															display={
																checkBoxCptCodes?.length <= 0 ? 'flex' : 'none'
															}
															justifyContent={'center'}
															alignItems={'center'}
															height={'100%'}
															sx={{
																fontSize: {
																	xl: '15px',
																	lg: '10px',
																	md: '9px',
																	sm: '9px',
																	xs: '9px',
																},
															}}
														>
															{' '}
															Write a Code Description to search
														</Grid>
													)}
													{/* Button Above Favorite CPT Codes */}
													{favoriteCptCodes != null && (
														<Box
															sx={{
																display: 'flex',
																alignItems: 'center',
																height: '50px',
																mr: '1rem',
																justifyContent: 'flex-end',
															}}
														>
															<TextField
																id="outlined-basic"
																placeholder="Search Cpt Codes"
																variant="outlined"
																size="small"
																value={searchFavCptCode}
																onChange={handleCptCodes}
																sx={{
																	'& .MuiOutlinedInput-root': {
																		borderRadius: '1rem', // Adjust border radius
																		height: '35px', // Adjust height
																		fontSize: '12px', // Adjust font size
																	},
																	'& .MuiInputLabel-root': {
																		fontSize: '12px', // Adjust label font size
																	},
																	'& .MuiOutlinedInput-input': {
																		fontSize: '12px', // Adjust input text font size
																	},
																}}
															/>
														</Box>
													)}
													{/* DropDown */}
													<Box
														sx={{
															opacity: showCptCodes ? 1 : 0,
															height: {
																xl: showCptCodes ? '29vh' : '0',
																lg: showCptCodes ? '29vh' : '0',
																md: showCptCodes ? '29vh' : '0',
																sm: showCptCodes ? '27vh' : '0',
																xs: showCptCodes ? '25vh' : '0',
															},
															transition: 'all 0.4s ease-in',
															border: showCptCodes
																? '1px solid #00000026'
																: 'none',
															margin: '0px 5px 5px 5px',
															borderBottomRightRadius: '5px',
															borderBottomLeftRadius: '5px',
															backgroundColor: 'white',
														}}
													>
														<Box
															sx={{
																opacity: showCptCodes ? 1 : 0,
																height: {
																	xl: showCptCodes ? '29vh' : '0',
																	lg: showCptCodes ? '29vh' : '0',
																	md: showCptCodes ? '29vh' : '0',
																	sm: showCptCodes ? '27vh' : '0',
																	xs: showCptCodes ? '25vh' : '0',
																},

																transition: 'all 1s ease-in',
															}}
														>
															{globalCptSearchLoading ? (
																<Grid
																	sx={{
																		display: 'flex',
																		justifyContent: 'center',
																		alignItems: 'center',
																		height: '100%',
																		opacity: showCptCodes ? 1 : 0,
																		height: {
																			xl: showCptCodes ? '24vh' : '0',
																			lg: showCptCodes ? '24vh' : '0',
																			md: showCptCodes ? '24vh' : '0',
																			sm: showCptCodes ? '22vh' : '0',
																			xs: showCptCodes ? '20vh' : '0',
																		},
																		transition: 'all 0.7s ease-in',
																	}}
																>
																	<CircularProgress />
																</Grid>
															) : (
																<Grid
																	sx={{
																		height: {
																			xl: showCptCodes ? '24vh' : '0',
																			lg: showCptCodes ? '24vh' : '0',
																			md: showCptCodes ? '24vh' : '0',
																			sm: showCptCodes ? '22vh' : '0',
																			xs: showCptCodes ? '20vh' : '0',
																		},
																		overflowY: 'auto',
																		'&::-webkit-scrollbar': {
																			width: '3.5px',
																		},
																		'&::-webkit-scrollbar-track': {
																			background: '#f1f1f1',
																		},
																		'&::-webkit-scrollbar-thumb': {
																			background: '#2E68BA',
																			borderRadius: '5px',
																		},
																		transition: 'all 1s ease-in',
																	}}
																	display={showCptCodes ? 'flex' : 'none'}
																	flexDirection={'column'}
																>
																	{searchCptData?.length === 0 && (
																		<Grid
																			width={'100%'}
																			display={'flex'}
																			justifyContent={'center'}
																			alignItems={'center'}
																			height={'100%'}
																		>
																			{' '}
																			No Match Found
																		</Grid>
																	)}
																	{searchCptData == null &&
																		favoriteCptCodes == null &&
																		showCptCodes && (
																			<Grid
																				width={'100%'}
																				display={'flex'}
																				justifyContent={'center'}
																				alignItems={'center'}
																				height={'100%'}
																				sx={{
																					fontSize: {
																						xl: '15px',
																						lg: '10px',
																						md: '9px',
																						sm: '9px',
																						xs: '9px',
																					},
																				}}
																			>
																				{' '}
																				Write a Code Description to search
																			</Grid>
																		)}
																	{searchCptData != null
																		? searchCptData?.map((item, key) => {
																				return (
																					<Box
																						key={key}
																						sx={{ m: '8px 0 0 2rem' }}
																					>
																						<Box display={'flex'} gap={'10px'}>
																							<Grid
																								display={'flex'}
																								gap={'10px'}
																							>
																								<input
																									type="checkbox"
																									checked={selectedCheckboxes?.some(
																										(items) =>
																											items?.CPTCode ==
																											item?.Code
																									)}
																									id={item?.Code}
																									onClick={() => {
																										handleCheckboxChange({
																											CPTCode: item?.Code,
																											Description:
																												item?.Description,
																										});
																									}}
																									style={{ cursor: 'pointer' }}
																								/>
																								<Grid minWidth={'70px'}>
																									<label
																										htmlFor={item?.Code}
																										style={{
																											color: '#1D60C5',
																											fontWeight: 600,
																											fontFamily: 'Poppins',
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																											cursor: 'pointer',
																										}}
																									>
																										{`${item?.Code}`}
																									</label>
																								</Grid>
																							</Grid>
																							<Box
																								display={'flex'}
																								alignItems={'center'}
																							>
																								<CustomWidthTooltip
																									arrow
																									title={item?.Description}
																									placement="top-start"
																								>
																									<Typography
																										fontWeight={400}
																										fontFamily={'Poppins'}
																										sx={{
																											fontSize: {
																												xl: '15px',
																												lg: '10px',
																												md: '9px',
																												sm: '9px',
																												xs: '9px',
																											},
																										}}
																									>
																										{item?.Description?.length >
																										65
																											? item?.Description?.slice(
																													0,
																													65
																												) + '....'
																											: item?.Description}
																									</Typography>
																								</CustomWidthTooltip>
																							</Box>
																						</Box>

																						<Divider color={'#DCE8FB'} />
																					</Box>
																				);
																			})
																		: filteredFavCptCodes != null
																			? filteredFavCptCodes?.map(
																					(item, key) => {
																						return (
																							<Box
																								key={key}
																								sx={{ m: '8px 0 0 2rem' }}
																							>
																								<Box
																									display={'flex'}
																									gap={'10px'}
																								>
																									<Grid
																										display={'flex'}
																										gap={'10px'}
																									>
																										<input
																											type="checkbox"
																											checked={selectedCheckboxes?.some(
																												(items) =>
																													items?.CPTCode ==
																													item?.Code
																											)}
																											id={item?.Code}
																											onClick={() => {
																												handleCheckboxChange({
																													CPTCode: item?.Code,
																													Description:
																														item?.CodeDescription,
																												});
																											}}
																											style={{
																												cursor: 'pointer',
																											}}
																										/>

																										<Grid minWidth={'70px'}>
																											<label
																												htmlFor={item?.Code}
																												style={{
																													color: '#1D60C5',
																													fontWeight: 600,
																													fontFamily: 'Poppins',
																													fontSize: {
																														xl: '15px',
																														lg: '10px',
																														md: '9px',
																														sm: '9px',
																														xs: '9px',
																													},
																													cursor: 'pointer',
																												}}
																											>
																												{`${item?.Code}`}
																											</label>
																										</Grid>
																									</Grid>
																									<Box
																										display={'flex'}
																										alignItems={'center'}
																									>
																										<CustomWidthTooltip
																											arrow
																											title={
																												item?.CodeDescription
																											}
																											placement="top-start"
																										>
																											<Typography
																												fontWeight={400}
																												fontFamily={'Poppins'}
																												sx={{
																													fontSize: {
																														xl: '15px',
																														lg: '10px',
																														md: '9px',
																														sm: '9px',
																														xs: '9px',
																													},
																												}}
																											>
																												{item?.CodeDescription
																													?.length > 65
																													? item?.CodeDescription?.slice(
																															0,
																															65
																														) + '....'
																													: item?.CodeDescription}
																											</Typography>
																										</CustomWidthTooltip>
																									</Box>
																								</Box>

																								<Divider color={'#DCE8FB'} />
																							</Box>
																						);
																					}
																				)
																			: ''}
																</Grid>
															)}
															<Box
																sx={{
																	opacity: showCptCodes ? 1 : 0,
																	height: showCptCodes ? '30px' : '0px',
																	transition: 'all 0.5s ease-in',
																}}
																display="flex"
																gap={'5px'}
																justifyContent={'flex-end'}
																margin={'auto 5px 5px 5px'}
															>
																<Button
																	onClick={() => {
																		setShowCptCodes(false);
																		setSearchCptData(null);
																		setSelectedCheckboxes([]);
																		setSearchRight('');
																	}}
																	variant="contained"
																	sx={{
																		backgroundColor: '#ED2828',
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																		'&:hover': {
																			backgroundColor: '#ED2828',
																		},
																	}}
																>
																	Cancel
																</Button>
																<Button
																	disabled={
																		searchCptData?.length <= 0 ? true : false
																	}
																	onClick={() => {
																		setCheckBoxCptCodes((pre) => {
																			const mergedDxCodes = [
																				...pre,
																				...selectedCheckboxes,
																			];
																			return Array.from(new Set(mergedDxCodes));
																		});
																		setShowCptCodes(false);
																		setSearchCptData(null);
																		setSearchRight('');
																		setSnackbarMessage('');
																	}}
																	variant="contained"
																	sx={{
																		backgroundColor: '#D76A05',
																		fontSize: {
																			xl: '15px',
																			lg: '10px',
																			md: '9px',
																			sm: '9px',
																			xs: '9px',
																		},
																		'&:hover': {
																			backgroundColor: '#D76A05',
																		},
																	}}
																>
																	Add
																</Button>
															</Box>
														</Box>
													</Box>
													{/* cpt Codes By post  */}
													{checkBoxCptCodes?.length > 0 && !showCptCodes && (
														<Box
															display={'flex'}
															flexDirection={'column'}
															gap={'5px'}
															m={'5px 0'}
															padding={'0 2px'}
															sx={{
																height: {
																	xl: '24vh',
																	lg: '29vh',
																	md: '29vh',
																	sm: '27vh',
																	xs: '25vh',
																},
																overflow: 'auto',
															}}
														>
															{checkBoxCptCodes?.map((item, i) => (
																<Box key={i}>
																	{changeCptCodes && (
																		<Box>
																			<Paper>
																				<CustomBoxDiagosis>
																					<Box
																						display={'flex'}
																						alignItems={'center'}
																					>
																						<CustomWidthTooltip
																							arrow
																							title={`${item?.CPTCode} [ ${item?.Description}]`}
																							placement="top-start"
																						>
																							<CustomTypoDiagosis
																								sx={{
																									fontSize: {
																										xl: '15px',
																										lg: '10px',
																										md: '9px',
																										sm: '9px',
																										xs: '9px',
																									},
																								}}
																							>
																								{item.CPTCode +
																									` [ ${item?.Description?.length > 50 ? item?.Description.slice(0, 50) + '...' : item?.Description} ] `}
																							</CustomTypoDiagosis>
																						</CustomWidthTooltip>
																					</Box>
																					<Box>
																						<IconButton
																							sx={{
																								ml: 'auto',
																							}}
																							onClick={() =>
																								handleRemoveCheckbox(item)
																							}
																						>
																							<CloseIcon
																								sx={{
																									color: '#ED2828',
																									fontSize: {
																										xl: '15px',
																										lg: '10px',
																										md: '9px',
																										sm: '9px',
																										xs: '9px',
																									},
																								}}
																							/>
																						</IconButton>
																					</Box>
																				</CustomBoxDiagosis>
																			</Paper>
																		</Box>
																	)}
																</Box>
															))}
														</Box>
													)}
												</Box>
											</Paper>
										</ClickAwayListener>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</Box>

					{/* Clinical Notes and Attachment */}
					<Grid
						container
						xl={12}
						lg={12}
						md={12}
						sm={12}
						xs={12}
						spacing={2}
						// sx={{ padding: '20px 0px 20px 0px' }}
					>
						<Grid item xl={6} lg={6} md={6} sm={12} xs={6}>
							<Typography
								color={'#BC1111'}
								fontWeight={500}
								fontFamily={'Poppins'}
								sx={{
									fontSize: {
										xl: '15px',
										lg: '10px',
										md: '9px',
										sm: '9px',
										xs: '9px',
									},
								}}
							>
								Additional Notes
							</Typography>
							<Box>
								<Box sx={{ display: 'flex', alignItems: 'center' }}>
									<TextField
										fullWidth
										multiline
										size="small"
										rows={3}
										name="select"
										value={additionalNotes}
										onChange={(e) => setAdditionalNotes(e.target.value)}
									/>
								</Box>
							</Box>
						</Grid>
						<Grid
							item
							xl={6}
							lg={6}
							md={6}
							sm={12}
							xs={12}
							display={'flex'}
							justifyContent={'space-between'}
							sx={{ marginTop: '-5px' }}
						>
							<div>
								<Typography
									color={'#BC1111'}
									fontWeight={500}
									fontFamily={'Poppins'}
									sx={{
										fontSize: {
											xl: '15px',
											lg: '10px',
											md: '9px',
											sm: '9px',
											xs: '9px',
										},
									}}
								>
									Attachments
								</Typography>
								<Box>
									<Button
										variant="contained"
										component="label"
										size="small"
										sx={{
											background: '#2E68BA',
											color: 'white',
											fontSize: {
												xl: '15px',
												lg: '10px',
												md: '9px',
												sm: '9px',
												xs: '9px',
											},
										}}
									>
										Select Files
										<input
											ref={InputSelectedFile}
											type="file"
											multiple
											style={{ display: 'none' }}
											onChange={handleFileSelect}
											accept=".pdf,.doc,.docx,.xls,.xlsx, .png, .jpg,.jpeg"
										/>
									</Button>
								</Box>
							</div>
							<Box sx={{ width: '70%' }}>
								{/* {(selectedFiles?.length > 0 || loading) && ( */}
								<Box
									p={0}
									m={0}
									sx={{
										display: 'flex',
										flexDirection: 'column',
										padding: ' 5px 10px',
										margin: ' 5px 10px',
										height: '15vh',
										overflow: 'auto',
										border: '1px solid lightgray',
									}}
								>
									{loading ? (
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												height: '150px',
											}}
										>
											<CircularProgress />
										</Box>
									) : selectedFiles?.length > 0 ? (
										<Box>
											{selectedFiles?.map((file, index) => {
												return (
													<Box
														key={index}
														display={'flex'}
														alignItems={'center'}
														gap={'5px'}
													>
														<Box
															display="flex"
															alignItems="center"
															justifyContent={'space-between'}
															sx={{
																borderRadius: '8px',
																background: '#EDFFF4',
																fontSize: '12px',
																padding: '5px',
																margin: '5px',
																border: '1px solid lightgray',
																width: '80%',
															}}
														>
															<Typography
																variant="body2"
																sx={{
																	mr: 1,
																	fontSize: {
																		xl: '15px',
																		lg: '10px',
																		md: '9px',
																		sm: '9px',
																		xs: '9px',
																	},
																}}
															>
																{file?.name || file?.AttachmentName}
															</Typography>
														</Box>
														<Box
															display={'flex'}
															alignItems={'center'}
															justifyContent={'center'}
															border={'1px solid black'}
															borderRadius={'5px'}
															sx={{ height: '25px', width: '25px' }}
														>
															<IconButton
																onClick={() => {
																	file?.id
																		? handleOpenDeleteModal(file)
																		: handleFileRemove(file);
																}}
																sx={{
																	cursor: 'pointer',
																	height: '20px',
																	width: '20px',
																}}
															>
																<CloseIcon
																	sx={{
																		color: 'red',
																		height: '15px',
																		width: '15px',
																	}}
																/>
															</IconButton>
														</Box>
														<Box
															display={file?.name ? 'none' : 'flex'}
															alignItems={'center'}
															justifyContent={'center'}
															border={'1px solid black'}
															borderRadius={'5px'}
															sx={{ height: '25px', width: '25px' }}
														>
															<IconButton
																onClick={() => {
																	handleDownload(
																		file?.Path,
																		file?.AttachmentName
																	);
																}}
																sx={{
																	cursor: 'pointer',
																	height: '20px',
																	width: '20px',
																}}
															>
																<DownloadIcon
																	sx={{
																		color: '#008000',
																		height: '15px',
																		width: '15px',
																	}}
																/>
															</IconButton>
														</Box>
													</Box>
												);
											})}
										</Box>
									) : (
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												height: '15vh',
											}}
										>
											<Typography>0 Files</Typography>
										</Box>
									)}
								</Box>
								{/* // )} */}
							</Box>
						</Grid>
					</Grid>
				</Box>
				{/* <Box
					sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: -4.5 }}
				>
					<Box
						sx={{
							padding: '5px',
							// border: '1px solid silver',
							width: '100%',
							maxWidth: '1320px',

							xs: { maxWidth: '100%' },
							sm: { maxWidth: '90%' },
							md: { maxWidth: '80%' },
						}}
					>
						{notes?.length !== 0 && (
							<Box sx={{ paddingLeft: '10px', marginTop: '-1px' }}>
								<div>
									<span
										style={{
											fontSize: '12px',
											fontWeight: '600',
											color: 'black',
										}}
									>
										Change History
									</span>
									<Box
										sx={{
											maxHeight: '88px',
											overflowY: 'auto',
											border: '1px solid silver',
										}}
									>
										{notes?.map((note) => (
											<Box
												key={id}
												style={{
													display: 'flex',
													alignItems: 'center',
													marginBottom: '10px',
												}}
											>
												<p
													style={{
														margin: 0,
														whiteSpace: 'nowrap',
														color: '#B0B0B0',
														fontStyle: 'italic',
														fontSize: '13px',
													}}
												>
													<span style={{ marginRight: '20px' }}>
														{dayjs(note.created_date).format('MMMM DD, YYYY')}
													</span>
													<span style={{ marginLeft: '20px' }}>{username}</span>
												</p>
												<p
													style={{
														margin: '0 0 0 10px',
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
														color: '#B0B0B0',
														fontStyle: 'italic', // Added italic
														fontSize: '10px', // Reduced font size
													}}
												>
													<span style={{ marginLeft: '20px' }}>
														<Tooltip title={note.note_text} placement="top">
															<span style={{ marginLeft: '20px' }}>
																{note.note_text?.length > 150
																	? note.note_text?.slice(0, 150) + '...'
																	: note.note_text}
															</span>
														</Tooltip>
													</span>
												</p>
											</Box>
										))}
									</Box>
								</div>
							</Box>
						)}
					</Box>
				</Box> */}
				<Box
					sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: -4.5 }}
				>
					<Box
						sx={{
							padding: '5px',
							width: '100%',
							maxWidth: '1320px',
							xs: { maxWidth: '100%' },
							sm: { maxWidth: '90%' },
							md: { maxWidth: '80%' },
						}}
					>
						{notes?.length !== 0 && showNotes && (
							<Box sx={{ paddingLeft: '10px', marginTop: '-1px' }}>
								{/* <div
									onClick={toggleNotes}
									style={{
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}
								>
									<HistoryIcon sx={{ marginRight: 1, color: '#0D406F' }} />
									<span
										style={{
											fontSize: '11px',
											fontWeight: '600',
											color: '#0D406F',
										}}
									>
										Change History
									</span>
								</div> */}
								{showNotes && (
									<Drawer
										anchor="right"
										open={showNotes}
										onClose={() => setShowNotes(false)}
										sx={{
											'& .MuiDrawer-paper': {
												...notesDrawerPaperSx,
											},
										}}
									>
										<Box sx={notesDrawerHeaderSx}>
											<Typography
												variant="h6"
												sx={{
													fontWeight: 700,
													color: '#172d58',
													fontFamily: 'Poppins',
													fontSize: '18px',
												}}
											>
												Notes History
											</Typography>
											<IconButton
												onClick={() => setShowNotes(false)}
												sx={{
													width: 34,
													height: 34,
													color: '#63718a',
													'&:hover': {
														backgroundColor: '#eef5ff',
														color: '#1f66ff',
													},
												}}
											>
												<CloseIcon />
											</IconButton>
										</Box>

										<Box sx={notesTableWrapSx}>
											<Box component="table" sx={notesTableSx}>
												<thead>
													<tr>
														<th style={{ width: 118 }}>Date</th>
														<th style={{ width: 150 }}>User Name</th>
														<th>Notes</th>
													</tr>
												</thead>
												<tbody>
													{notes?.map((note) => (
														<tr key={note.id}>
															<td>
																{dayjs(note.created_date).format(
																	'MMM DD, YYYY'
																)}
															</td>
															<td>{note?.created_by_name}</td>
															<td>
																<Tooltip title={note.note_text} placement="top">
																	<span>
																		{note.note_text?.length > 150
																			? note.note_text?.slice(0, 150) + '...'
																			: note.note_text}
																	</span>
																</Tooltip>
															</td>
														</tr>
													))}
												</tbody>
											</Box>
										</Box>
									</Drawer>
								)}
							</Box>
						)}
					</Box>
				</Box>

				<Box
					display={'flex'}
					justifyContent={'flex-end'}
					gap={'10px'}
					sx={{ m: '0.1rem 2rem 0.1rem 2rem' }}
					style={{ position: 'absolute', bottom: '10px', right: '10px' }}
				>
					{' '}
					<CustomButton
						onClick={() => toggleNotes()}
						variant="contained"
						sx={{ backgroundColor: '#2E68BA', cursor: 'pointer' }}
					>
						Notes History
					</CustomButton>
					<CustomButton
						onClick={() => navigate('/charges')}
						variant="contained"
						sx={{ backgroundColor: '#ED2828', cursor: 'pointer' }}
					>
						Cancel
					</CustomButton>
					<CustomButton
						// disabled={
						// 	checkBoxCptCodes?.length <= 0
						// 		? true
						// 		: checkBoxDxCodes?.length <= 0
						// 			? true
						// 			: false
						// }
						onClick={() => {
							if (checkBoxCptCodes?.length < 1) {
								setSnackbarMessage('CPT Code must be selected');
								setOpenSnackbar(true);
							} else {
								editVisit(visitId || PatientVisitId, updateData);
								notes_PatientUpdateInformation(notesLogBodyJson);
							}
						}}
						variant="contained"
						sx={{ backgroundColor: '#D76A05' }}
						disabled={editSave ? true : false}
					>
						Save
					</CustomButton>
				</Box>
				{/* SnackBar */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={1000}
					onClose={handleCloseSnackbar}
					anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
				>
					<Alert
						onClose={handleCloseSnackbar}
						severity={
							!postSucessfully || snackbarMessage !== '' ? 'error' : 'success'
						}
						variant="filled"
						sx={{
							// width: '100%',
							height: '3rem',
							textAlign: 'center',
							fontSize: {
								xl: '14px',
								lg: '14px',
								md: '14px',
								sm: '12px',
								xs: '12px',
							},
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
						action={
							<React.Fragment>
								<span
									onClick={handleCloseSnackbar}
									style={{
										cursor: 'pointer',
										m: 'auto 0',
										fontSize: '13px',
										color: 'rgb(231, 231, 231)',
									}}
								>
									Close
								</span>
							</React.Fragment>
						}
					>
						{/* {!postSucessfully ? 'Error' : 'Edit Charge Successfully!'}
						{!postSucessfully ? snackbarMessage || 'Error' : 'Edit Charge Successfully!'} */}
						{!postSucessfully
							? 'Error'
							: snackbarMessage !== ''
								? snackbarMessage
								: 'Edit Charge Successfully!'}
					</Alert>
				</Snackbar>
			</Box>
			{/* delete Attachment file */}
			<Modal
				open={openDeleteModal}
				onClose={handleCloseDeleteModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box display={'flex'} justifyContent={'flex-end'}>
						<IconButton
							sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
							onClick={handleCloseDeleteModal}
						>
							<CloseIcon sx={{ color: '#ED2828' }} />
						</IconButton>
					</Box>
					<Box display={'flex'} flexDirection={'column'} gap={'10px'}>
						<Typography
							id="modal-modal-title"
							variant="h5"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Confirm?
						</Typography>
						<Typography
							id="modal-modal-title"
							variant="h6"
							align="center"
							fontWeight={'bold'}
							component="h2"
						>
							Are You Sure To Delete Attachment File?
						</Typography>
						<Box display={'flex'} justifyContent={'center'} gap={'14px'}>
							<Button
								variant="contained"
								sx={{ bgcolor: '#ED2828', width: '90px', py: '8px' }}
								onClick={handleCloseDeleteModal}
							>
								Cancel
							</Button>
							{/* <Button
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '90px', py: '8px' }}
								onClick={() => {
									deleteChooseFile(fileId?.id, {
										Deleted: true,
									});
									handleFileRemove(fileId);
									handleCloseDeleteModal();
								}}
							>
								Delete
							</Button> */}
							<Button
								variant="contained"
								sx={{ bgcolor: '#FD7702', width: '90px', py: '8px' }}
								onClick={async () => {
									const deletedFileName = await deleteChooseFile(fileId?.id, {
										Deleted: true,
									});

									const actionNotes = [
										{
											NotesText: `Attachment '${deletedFileName || 'unknown'}' is deleted`,
										},
									];
									const notesLogBodyJson = {
										Patientid: patientById,
										Visit_id: visitId,
										NoteCategory: 'charge',
										practice_id: practiceID,
										Platform: 'web',
										Notes: actionNotes,
									};
									await postPatNotes(notesLogBodyJson);

									await deleteChooseFile(fileId?.id, { Deleted: true });
									handleFileRemove(fileId);
									handleCloseDeleteModal();
								}}
							>
								Delete
							</Button>
						</Box>
					</Box>
				</Box>
			</Modal>
			{/* Past visit data  */}
			<Modal
				open={openModal}
				// onClose={handleCloseModal}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						alignItems={'center'}
						bgcolor={'#3A7CE0'}
						padding={'5px 10px'}
						sx={{
							borderTopRightRadius: '10px',
							borderTopLeftRadius: '10px',
						}}
					>
						<Typography
							id="modal-modal-title"
							fontSize={'16px'}
							align="center"
							fontWeight={'bold'}
							component="h2"
							color={'white'}
						>
							Past Visits
						</Typography>
						<IconButton
							sx={{ height: '20px', width: '20px', cursor: 'pointer' }}
							onClick={handleCloseModal}
						>
							<CloseIcon sx={{ color: 'white' }} />
						</IconButton>
					</Box>
					<Box
						display={'flex'}
						flexDirection={'column'}
						gap={'5px'}
						margin={'5px 10px'}
						sx={{
							overflowY: 'auto',
						}}
					>
						{filteredVisitData?.map((item, key) => {
							const dxCodesAndDescriptions = [];
							for (let i = 1; i <= 12; i++) {
								const dxCode = item[`Dxcode${i}`];
								const dxDescription = item[`Dx${i}Description`];
								if (dxCode !== null && dxCode) {
									dxCodesAndDescriptions.push({
										DxCode: dxCode,
										Description: dxDescription,
									});
								}
							}
							return (
								<Box key={key}>
									<Box
										display={'flex'}
										justifyContent={'space-between'}
										alignItems={'center'}
										bgcolor={'#3A7CE0'}
										padding={'5px 10px'}
										sx={{
											border: '2px solid #3A7CE0',
											borderTopRightRadius: '10px',
											borderTopLeftRadius: '10px',
										}}
									>
										<Box display={'flex'} gap={'15px'}>
											<Typography
												id="modal-modal-title"
												fontSize={'14px'}
												align="center"
												fontWeight={'bold'}
												component="h2"
												color={'white'}
											>
												Visit Date
											</Typography>
											<Typography
												id="modal-modal-title"
												fontSize={'14px'}
												align="center"
												component="h2"
												color={'white'}
											>
												{formatAdmissionDate(item?.VisitDate)}
											</Typography>
										</Box>
									</Box>
									<Box
										display={'flex'}
										gap={'3px'}
										padding={'5px'}
										sx={{
											border: '2px solid #00000026',
											borderTop: 'none',
											flexWrap: 'wrap',
											maxHeight: '200px',
											overflowY: 'auto',
										}}
									>
										<Typography fontWeight={'bold'} fontSize={'14px'}>
											DX Codes:
										</Typography>
										{dxCodesAndDescriptions?.length === 0 && (
											<Box display={'flex'} gap={'3px'}>
												<Typography fontSize={'12px'}>No Dx Added</Typography>
											</Box>
										)}
										{dxCodesAndDescriptions?.map((item, key) => {
											return (
												<>
													<Box key={key}>
														<Box display={'flex'} gap={'5px'}>
															<Typography fontSize={'14px'}>
																{`${item?.DxCode}` + ', '}
															</Typography>
														</Box>
													</Box>
												</>
											);
										})}
										{dxCodesAndDescriptions?.length != 0 && (
											<input
												value={dxCheckData}
												disabled={selectedDx && selectedDx !== item?.id}
												onChange={(e) => {
													const isChecked = e.target.checked;
													setDxCheckData(isChecked);
													setSelectedDxCodes(dxCodesAndDescriptions);
													if (isChecked) {
														setSelectedDx(e.target.id);
													} else {
														setSelectedDx(null);
													}
												}}
												type="checkbox"
												id={item?.id}
												style={{ cursor: 'pointer', marginLeft: 'auto' }}
											/>
										)}
									</Box>
									<Box
										display={'flex'}
										gap={'3px'}
										padding={'5px'}
										sx={{
											border: '2px solid #00000026',
											borderTop: 'none',
										}}
									>
										<Typography fontWeight={'bold'} fontSize={'14px'}>
											CPT Codes:
										</Typography>
										{item?.visit_cpts?.map((item, key) => {
											return (
												<Box key={key}>
													<Box display={'flex'} gap={'5px'}>
														<Typography fontSize={'14px'}>
															{`${item?.CPTCode}` +
																`${item?.CPTCode?.length > 0 ? ', ' : 'No CPT Added'}`}
														</Typography>
													</Box>
												</Box>
											);
										})}
										{item?.visit_cpts[0].CPTCode != '' && (
											<input
												value={cptCheckData}
												disabled={selectedCpt && selectedCpt !== item?.id}
												onChange={(e) => {
													const isChecked = e.target.checked;
													setCptCheckData(isChecked);
													if (isChecked) {
														setCptCheckData(true);
														setSelectedCheckboxes(visitCpts);
														setSelectedCpt(e.target.id);
													} else {
														setCptCheckData(false);
														setSelectedCheckboxes([]);
														setSelectedCpt(null);
													}
													var visitCpts = item?.visit_cpts?.map((items) => ({
														CPTCode: items?.CPTCode,
														Description: items?.Description,
													}));
													setSelectedCheckboxes(visitCpts);
												}}
												type="checkbox"
												id={item?.id}
												style={{ cursor: 'pointer', marginLeft: 'auto' }}
											/>
										)}
									</Box>
								</Box>
							);
						})}
					</Box>
					<Box
						display={'flex'}
						justifyContent={'center'}
						gap={'14px'}
						margin={'5px 0'}
					>
						<Button
							variant="contained"
							sx={{ bgcolor: '#ED2828', width: '80px', py: '5px' }}
							onClick={() => {
								handleCloseModal();
							}}
						>
							Cancel
						</Button>
						<Button
							disabled={dxCheckData || cptCheckData ? false : true}
							variant="contained"
							sx={{ bgcolor: '#FD7702', width: '80px', py: '5px' }}
							onClick={() => {
								handleCloseModal();
								setCheckBoxDxCodes(selectedDxCodes);
								setCheckBoxCptCodes(selectedCheckboxes);
							}}
						>
							Add
						</Button>
					</Box>
				</Box>
			</Modal>
		</Box>
	);
}
// custom styling
// Custom Box of Diagnosis Head
const DiagnosisBox = styled(Box)(({ theme }) => ({
	backgroundColor: '#2E68BA',
	padding: '8px 1rem',
	display: 'flex',
	justifyContent: 'space-between',
	borderTopLeftRadius: '5px',
	borderTopRightRadius: '5px',
}));
// custom Box of close Box of Diagosis
const CustomBoxDiagosis = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	backgroundColor: '#ECF4FF',
	padding: '0px 10px',
	borderRadius: '5px',
	border: '1px solid #00000026',
}));
const CustomTypoDiagosis = styled(Typography)(({ theme }) => ({
	color: '#065AD8',
	fontWeight: 400,
	fontFamily: 'Poppins',
	fontSize: '15px',
	lineHeight: '22.5px',
	[theme.breakpoints.down('sm')]: {
		fontSize: '13px',
	},
}));
// custom Button
const CustomButton = styled(Button)(({ theme }) => ({
	width: '130px',
	height: '40px',
	fontWeight: 500,
	fontFamily: 'Poppins',
	cursor: 'pointer',
	fontSize: '17px',
	lineHeight: '25px',
	[theme.breakpoints.down('md')]: {
		width: '110px',
		height: '40px',
		fontSize: '16px',
		lineHeight: '20px',
	},
	[theme.breakpoints.up('lg')]: {
		width: '100px',
		height: '35px',
		fontSize: '14px',
		lineHeight: '18px',
	},
}));
// Modal
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: { xl: 500, lg: 500, sm: 450, md: 500, xs: 400 },
	maxHeight: '500px',
	bgcolor: 'background.paper',
	// boxShadow: 24,
	borderRadius: '10px',
	// p: '10px',
	display: 'flex',
	flexDirection: 'column',
	gap: '5px',
};
const CustomWidthTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 500,
		backgroundColor: 'gray',
		fontSize: '12px',
	},
});
// auto complete
const StyledTextField = styled(TextField)(({ theme }) => ({
	'& .MuiOutlinedInput-root': {
		borderRadius: '1.2rem',
		'& fieldset': {
			borderRadius: '1.2rem',
		},
		'&:hover fieldset': {
			borderColor: theme.palette.primary.main,
		},
		'&.Mui-focused fieldset': {
			borderColor: theme.palette.primary.main,
		},
	},
	'& .MuiInputLabel-outlined': {
		transform: 'translate(14px, 7px) scale(1)',
		fontSize: '14px',
		backgroundColor: 'transparent',
	},
	'& .MuiInputLabel-shrink': {
		transform: 'translate(14px, -6px) scale(0.75)',
		// backgroundColor: theme.palette.background.paper,
		fontSize: '15px',
		color: '#f49546',
		padding: '0 5px',
	},
	'& ::placeholder': {
		fontSize: '11px',
		opacity: 1,
	},
}));
